import type { Messages } from './en'

export const id: Messages = {
  // ─── Navigasi ─────────────────────────────────────────────────
  nav: {
    home: 'Beranda',
    calendar: 'Kalender',
    explore: 'Jelajahi',
    tickets: 'Tiket',
    create: 'Buat',
    createEvent: 'Buat Event',
    myEvents: 'Event Saya',
    profile: 'Profil',
    tapIn: 'Tap In',
    account: 'Akun',
    login: 'Masuk',
    signIn: 'Masuk',
    signOut: 'Keluar',
    back: 'Kembali',
    expandSidebar: 'Perluas sidebar',
    collapseSidebar: 'Ciutkan sidebar',
  },

  // ─── Judul Halaman ────────────────────────────────────────────
  pages: {
    auth: 'Masuk',
    calendar: 'Kalender',
    create: 'Buat',
    myEvents: 'Event Saya',
    profile: 'Profil',
    event: 'Event',
    eventSettings: 'Pengaturan Event',
    notifications: 'Notifikasi',
    editProfile: 'Edit Profil',
    ticket: 'Tiket',
    explore: 'Jelajahi',
  },

  // ─── Autentikasi ──────────────────────────────────────────────
  auth: {
    signIn: 'Masuk',
    signUp: 'Daftar',
    welcomeBack: 'Selamat Datang Kembali',
    createAccount: 'Buat Akun Anda',
    signInSubtitle: 'Masuk ke akun Anda untuk melanjutkan',
    signUpSubtitle: 'Buat akun baru untuk memulai',
    signUpMethodsLabel: 'Daftar menggunakan salah satu metode di bawah:',
    signInMethodsLabel: 'Masuk menggunakan salah satu metode di bawah:',
    orContinueWith: 'Atau lanjutkan dengan',
    continueWithGoogle: 'Lanjutkan dengan Google',
    continueWithApple: 'Lanjutkan dengan Apple',
    continueWithWallet: 'Hubungkan Wallet',
    alreadyHaveAccount: 'Sudah memiliki akun?',
    linking: 'Menautkan...',
    connecting: 'Menghubungkan...',
    linkGoogle: 'Tautkan Google',
    linkApple: 'Tautkan Apple',
    appleNotAvailable: 'Masuk dengan Apple belum tersedia',
    popupBlocked: 'Popup diblokir. Izinkan popup untuk situs ini.',
    unexpectedError: 'Terjadi kesalahan yang tidak terduga',
    oauthFailed: 'Autentikasi OAuth gagal',
    initializing: 'Memulai...',
    walletUnavailable: 'Dompet Solana tidak tersedia. Gunakan ekstensi dompet yang didukung atau aplikasi seluler.',
    walletAuthFailed: 'Autentikasi dompet gagal',
    walletAuthError: 'Gagal mengautentikasi dengan dompet',
    signingUp: 'Mendaftar...',
    signingIn: 'Masuk...',
    signUpWithWallet: 'Daftar dengan Dompet',
    signInWithWallet: 'Masuk dengan Dompet',
    missingOAuthToken: 'Token OAuth tidak ditemukan',
    authFailed: 'Autentikasi gagal',
    sessionNotVerified: 'Sesi tidak dapat diverifikasi. Silakan coba masuk lagi.',
    completingSignIn: 'Menyelesaikan masuk...',
    redirecting: 'Mengarahkan ke masuk...',
    introBadge: 'Tanpa dompet. Tanpa ribet.',
    introHeadlineSignIn: 'Selamat datang kembali di',
    introHeadlineSignUp: 'Bergabung dengan',
    introHighlight: 'ekosistem',
    introBodySignIn: 'Masuk untuk melihat tiket, event mendatang, dan rekomendasi personal Anda. Semuanya berjalan lancar.',
    introBodySignUp: 'Buat akun untuk RSVP event, mengadakan event sendiri, dan mendapatkan reward ekosistem — tanpa perlu pengetahuan kripto.',
    introFeaturePasswordless: 'Masuk tanpa kata sandi',
    introFeaturePasswordlessDesc: 'Masuk dengan Google atau Apple — tanpa kata sandi yang perlu diingat.',
    introFeatureWallet: 'Dompet opsional',
    introFeatureWalletDesc: 'Mahir? Tautkan dompet kripto untuk fitur opsional. Kebanyakan orang tidak perlu.',
    termsAgreement: 'Dengan melanjutkan, Anda menyetujui',
    terms: 'Ketentuan',
    and: 'dan',
    privacy: 'Kebijakan Privasi',
  },

  // ─── Jelajah ──────────────────────────────────────────────────
  explore: {
    title: 'Jelajahi Event',
    searchPlaceholder: 'Cari event berdasarkan judul atau deskripsi...',
    search: 'Cari',
    activeFilters: 'Filter aktif:',
    clearAll: 'Hapus semua',
    enterSearchTerm: 'Masukkan kata kunci atau terapkan filter untuk menemukan event',
    failedToSearch: 'Gagal mencari event.',
    retry: 'Coba lagi',
    found_one: 'Ditemukan {{count}} event',
    found_other: 'Ditemukan {{count}} event',
    noResults: 'Tidak ada event ditemukan',
    tryDifferent: 'Coba kata kunci atau filter lain',
    backToHome: 'Kembali ke Beranda',
    eventsIn: 'Event di {{location}}',
    filterCityPlaceholder: 'Filter berdasarkan kota...',
    filterLocationType: 'Tipe lokasi',
    filterDaysAhead: 'Hari ke depan',
    filterAllTypes: 'Semua tipe',
    filterInPerson: 'Tatap muka',
    filterOnline: 'Daring',
    filterHybrid: 'Hibrida',
    filterNext7Days: '7 hari ke depan',
    filterNext14Days: '14 hari ke depan',
    filterNext30Days: '30 hari ke depan',
    filterNext90Days: '90 hari ke depan',
    applyFilters: 'Terapkan filter',
  },

  // ─── Detail Event ────────────────────────────────────────────
  eventDetail: {
    notFound: 'Event Tidak Ditemukan',
    notFoundDescription: 'Event yang Anda cari tidak ada.',
    private: 'Event Privat',
    privateDescription: 'Event ini bersifat privat. Masuk atau gunakan tautan undangan untuk melihatnya.',
    loadError: 'Gagal Memuat Event',
    loadErrorDescription: 'Terjadi kesalahan saat memuat event ini. Silakan coba lagi.',
    tryAgain: 'Coba Lagi',
    goHome: 'Ke Beranda',
    joinNow: 'Gabung Sekarang \u2014 Event Sedang Berlangsung',
  },

  // ─── Event Saya ─────────────────────────────────────────────
  myEvents: {
    title: 'Event Saya',
    subtitle: 'Kelola event yang Anda selenggarakan dan hadiri',
    createEvent: 'Buat Event',
    organizing: 'Menyelenggarakan',
    attending: 'Menghadiri',
    collaborating: 'Berkolaborasi',
    tickets: 'Tiket',
    eventsOrganizing: 'Event yang Saya Selenggarakan',
    communityEventsHosting: 'Event komunitas yang saya hosting',
    sideEvent: 'side event',
    upcoming: 'Akan Datang',
    past: 'Sebelumnya',
    noUpcoming: 'Tidak ada event komunitas mendatang',
    noPast: 'Tidak ada event komunitas sebelumnya',
    coverImage: 'Gambar sampul untuk {{title}}',
    nft: 'NFT',
    partOf: 'Bagian dari',
    eventsAttending: 'Event yang Saya Hadiri',
    communityEventsAttending: 'Event komunitas yang Anda hadiri',
    eventsCollaborating: 'Event yang Saya Kolaborasi',
    organizingWithCount: 'Menyelenggarakan ({{count}})',
    attendingWithCount: 'Menghadiri ({{count}})',
    collaboratingWithCount: 'Berkolaborasi ({{count}})',
    ticketsWithCount: 'Tiket ({{count}})',
    sideEventCount_one: '{{count}} side event',
    sideEventCount_other: '{{count}} side event',
    eventCount_one: '{{count}} event',
    eventCount_other: '{{count}} event',
    noEventsFound: 'Event tidak ditemukan',
    noUpcomingEvents: 'Tidak ada event mendatang',
    noPastEvents: 'Tidak ada event sebelumnya',
    collaborator: 'Kolaborator',
  },

  // ─── Kalender ────────────────────────────────────────────────
  calendar: {
    title: 'Kalender Event',
    description: 'Temukan event mendatang dan jelajahi berdasarkan bulan, minggu, atau hari.',
    eventTypes: 'Tipe Event',
    publicEvent: 'Event Publik',
    privateEvent: 'Event Pribadi',
    attendingConfirmed: 'Menghadiri (Terkonfirmasi)',
    pendingApproval: 'Menunggu Persetujuan',
    onWaitlist: 'Dalam Daftar Tunggu',
    filters: 'Filter',
    done: 'Selesai',
    keyboardShortcuts: 'Pintasan Keyboard',
    close: 'Tutup',
    previousPeriod: 'Periode sebelumnya',
    nextPeriod: 'Periode berikutnya',
    goToToday: 'Ke hari ini',
    monthView: 'Tampilan bulan',
    weekView: 'Tampilan minggu',
    dayView: 'Tampilan hari',
    listView: 'Tampilan daftar',
    showShortcuts: 'Tampilkan pintasan',
    closeEscape: 'Tutup / Escape',
    calendar: 'Kalender',
    today: 'Hari Ini',
    month: 'Bulan',
    week: 'Minggu',
    day: 'Hari',
    list: 'Daftar',
    keyboardShortcutsTitle: 'Pintasan keyboard (?)',
    previous: 'Sebelumnya',
    allEvents: 'Semua Event',
    next: 'Berikutnya',
    noUpcomingEvents: 'Tidak ada event mendatang',
    dateTbd: 'Tanggal TBD',
    noEventsScheduled: 'Tidak ada event terjadwal',
    noEvents: 'Tidak ada event',
    ended: 'Berakhir',
    filterCityPlaceholder: 'Masukkan kota',
    filterCountryPlaceholder: 'Masukkan negara',
    attendeeCount_one: '{{count}} peserta',
    attendeeCount_other: '{{count}} peserta',
    eventsOnDate: 'Event pada {{date}}',
    dayModalDesc: 'Lihat dan berinteraksi dengan semua event pada tanggal ini',
    eventCount_one: '{{count}} event',
    eventCount_other: '{{count}} event',
    noEventsScheduledDay: 'Tidak ada event terjadwal untuk hari ini',
    hybridLocation: 'Hybrid • {{location}}',
    peopleGoing_one: '{{count}} orang hadir',
    peopleGoing_other: '{{count}} orang hadir',
  },

  // ─── Landing (logged-out marketing) ───────────────────────────
  landing: {
    nav: {
      ariaLabel: 'Navigasi landing',
      mobileAriaLabel: 'Navigasi landing mobile',
      openMenu: 'Buka menu',
      closeMenu: 'Tutup menu',
      menuTitle: 'Navigasi',
      explore: 'Jelajahi',
      partners: 'Mitra',
      ecosystem: 'Ekosistem',
      tapIn: 'Tap In',
      roadmap: 'Roadmap',
      signIn: 'Masuk',
      createEvent: 'Buat Event',
    },
    hero: {
      metaTitle: 'Creatix — Event Hub & Ekosistem | Pilot di Jogja',
      metaDescription:
        'Platform ekosistem event pertama di Indonesia yang menggabungkan kemudahan tiket berbayar dengan bukti kehadiran yang transparan. Didukung Solana, Metaplex, dan Superteam Indonesia. Rasakan layanan eksekusi penuh (Tap In) pilot di Yogyakarta & sekitarnya.',
      wordmark: 'creatix',
      displayLine1: 'Ekosistem event',
      displayLine2: 'berbasis jaringan, bukan iklan.',
      drivenByPrefix: 'didorong oleh',
      rotatorSuffix: ',',
      displaySuffix: 'bukan iklan.',
      rotatorWords: ['jaringan', 'brand', 'kreator', 'hub'],
      subhead:
        'Event hub pertama Indonesia—platform tempat penyelenggara, komunitas, dan brand tumbuh bersama melalui jaringan yang saling menguatkan. Jual tiket melalui payment gateway seperti platform biasa—setiap tiket diamankan dengan bukti kehadiran anti-temper. Tanpa dompet. Tanpa ribet. Hanya tiket event yang aman.',
      subLine1:
        'Event hub pertama Indonesia—platform tempat penyelenggara, komunitas, dan brand tumbuh bersama melalui jaringan yang saling menguatkan.',
      subLine2:
        'Jual tiket melalui Payment Gateway seperti platform event pada umumnya. Di balik layar, setiap tiket diamankan dengan bukti kehadiran anti-temper. Tanpa dompet kripto. Tanpa ribet. Hanya tiket event yang aman.',
      searchPlaceholder: 'Cari event, komunitas, kota, atau hub...',
      primaryCta: 'Gabung Ekosistem',
      secondaryCta: 'Jelajahi Event',
      slideshowAriaLabel: 'Slideshow event hero',
      supportedBy: 'Didukung infrastruktur global',
      audiencePill: 'Dibangun untuk penyelenggara & komunitas',
      eyebrowKeywords: 'Event Hub · Pertumbuhan Jaringan · Pilot Tap In',
    },
    howItWorks: {
      label: 'Cara Kerjanya',
      title: 'Creatix bukan sekadar direktori. Ini mesin pertumbuhan.',
      titleLine1: 'Creatix bukan sekadar direktori.',
      titleLine2: 'Ini mesin pertumbuhan.',
      titleHighlightPrefix: 'Ini',
      titleHighlight: 'mesin pertumbuhan',
      subtitle:
        'Setiap event yang Anda selenggarakan memperkuat seluruh ekosistem—dan ekosistem mempromosikan event Anda kembali—tanpa biaya tambahan.',
      rotatingLines: [
        'Setiap event yang Anda selenggarakan memperkuat seluruh ekosistem—dan ekosistem mempromosikan event Anda kembali.',
        'Creatix bukan sekadar direktori. Ini mesin pertumbuhan.',
        'Promosi organik lintas mitra—tanpa biaya tambahan.',
      ],
      step1: {
        title: 'Buat Event Anda (Gratis atau Berbayar)',
        photoAlt: 'Penyelenggara menyiapkan event di panggung sebelum pintu dibuka',
        platform: 'Manajemen event lengkap—check-in QR, daftar peserta otomatis, dashboard analitik real-time.',
        ecosystem: 'Event Anda langsung terindeks dan terlihat oleh semua mitra dalam network hub.',
      },
      step2: {
        title: 'Hubungkan ke Hub & Perluas Jangkauan',
        photoAlt: 'Peserta berinteraksi dan terhubung di meetup komunitas',
        platform: 'Kelola banyak co-host, speaker, dan vendor dari satu dashboard kolaboratif.',
        ecosystem:
          'Event Anda otomatis mendapat promosi organik lintas basis audiens mitra ekosistem—mengurangi biaya iklan berbayar.',
      },
      step3: {
        title: 'Skala & Pilih Jalur Pertumbuhan',
        photoAlt: 'Aktivasi workshop dengan peserta yang terlibat',
        platform: 'Jual tiket langsung melalui Creatix dengan biaya platform transparan (mirip Loket/Eventbrite). Event komunitas gratis tetap 100% gratis.',
        ecosystem:
          'Wujudkan talk show, workshop, atau meetup komunitas di wilayah pilot—tim kami hadir langsung untuk manajemen penuh.',
        autonomousPath: 'Jalur Mandiri',
        executionPath: 'Jalur Eksekusi (Tap In)',
      },
    },
    featureTabs: {
      label: 'Platform',
      titleLine1: 'Satu platform.',
      titleLine2: 'Pertumbuhan menyeluruh.',
      subtitle:
        'Dari event pertama hingga jaringan yang saling menguatkan—Creatix mencakup setiap langkahnya.',
      tab1: {
        label: 'Buat',
        title: 'Buat Event Anda',
        body: 'Gratis atau berbayar, online atau tatap muka. Check-in QR, daftar peserta otomatis, dan dashboard analitik real-time sudah bawaan—tanpa alat tambahan.',
      },
      tab2: {
        label: 'Hubungkan',
        title: 'Hubungkan ke Hubs',
        body: 'Co-host, pembicara, dan mitra ekosistem dalam satu dashboard kolaboratif. Event Anda terindeks dan dipromosikan silang ke audiens setiap mitra.',
      },
      tab3: {
        label: 'Skalakan',
        title: 'Skalakan Pertumbuhan',
        body: 'Jual tiket via payment gateway familiar sambil tiap tiket diam-diam diamankan dengan bukti kehadiran anti-temper. Event gratis tetap 100% gratis.',
      },
    },
    socialProof: {
      label: 'Bukti Sosial',
      title: 'Creatix adalah tempat ekosistem event dinamis Indonesia berkumpul.',
      tagline: 'Dibutuhkan dan Dipercaya Penyelenggara, Komunitas, dan Brand.',
      titleLine1: 'Dibutuhkan dan Dipercaya',
      titleLine2: 'Penyelenggara, Komunitas, dan Brand.',
      supportingText:
        'Dari meetup komunitas gratis hingga aktivasi brand skala besar—Creatix adalah tempat ekosistem event dinamis Indonesia berkumpul.',
      rotatingLines: [
        'Dibutuhkan dan Dipercaya Penyelenggara, Komunitas, dan Brand.',
        'Dari meetup komunitas gratis hingga aktivasi brand skala besar.',
        'Creatix adalah tempat ekosistem event dinamis Indonesia berkumpul.',
      ],
      metric: {
        eventsHosted: '50+',
        eventsHostedLabel: 'Event',
        activePartners: '20+',
        activePartnersLabel: 'mitra event ekosistem',
        verifiedUsers: '1.200+',
        verifiedUsersLabel: 'pengguna aktif',
      },
      andManyMore: 'dan masih banyak lagi',
    },
    tapIn: {
      statusBadge: 'Fase Pilot Terbatas — Yogyakarta & Sekitarnya',
      tagline: 'Creatix Tap In — Eksekusi Layanan Penuh',
      title: 'Kami turun langsung. Dimulai dari Jogja.',
      titleLine1: 'Kami turun langsung.',
      titleLine2: 'Dimulai dari Jogja.',
      subtitle:
        'Tim Creatix hadir fisik di Yogyakarta untuk mengeksekusi infrastruktur event kelas atas—mengubah peserta pasif menjadi kontributor aktif. Kami berkolaborasi dengan talenta lokal untuk talk show, meetup komunitas, workshop, dan event sosial & olahraga berkualitas tinggi.',
      rotatingLines: [
        'Creatix Tap In — Eksekusi Layanan Penuh',
        'Kami turun langsung. Dimulai dari Jogja.',
        'Mengubah peserta pasif menjadi kontributor aktif.',
      ],
      photoAlt: 'Tim lapangan Creatix memfasilitasi workshop di Yogyakarta',
      photoCaption: 'Tim lapangan · pilot Jogja',
      services: {
        colHeaders: {
          type: 'Jenis Event',
          team: 'Tim Lapangan',
          outcome: 'Hasil Nyata untuk Klien',
        },
        talkshow: {
          type: 'Talkshow & Panel',
          team: 'Tim Creatix + EO Lokal Jogja',
          outcome:
            'Event dieksekusi presisi, audiens teredukasi, laporan transparan, dan dokumentasi lengkap.',
        },
        meetup: {
          type: 'Meetup Komunitas',
          team: 'Koordinasi End-to-End Penuh',
          outcome: 'Komunitas lokal saling terhubung, visibilitas brand meningkat, dan dampak jaringan terukur.',
        },
        workshop: {
          type: 'Workshop & Sosial/Olahraga',
          team: 'Ahli & Fasilitator Lokal',
          outcome: 'Pengalaman interaktif autentik untuk peserta dan portofolio berkualitas untuk mitra.',
        },
      },
      whatsappCta: 'Hubungi Tim Creatix Jogja',
      form: {
        title: 'Ajukan Eksekusi Tap In',
        name: 'Nama',
        email: 'Email',
        communityOrBrand: 'Komunitas / Brand',
        eventCategory: 'Kategori Event',
        eventCategoryOptions: {
          talkshow: 'Talkshow & Panel',
          meetup: 'Meetup Komunitas',
          workshop: 'Workshop & Sosial/Olahraga',
          social_sport: 'Event Sosial & Olahraga',
        },
        estimatedDate: 'Perkiraan Tanggal',
        description: 'Deskripsi Rencana Event',
        submit: 'Kirim Permintaan',
        successTitle: 'Permintaan terkirim',
        successDesc: 'Tim Creatix akan segera menghubungi Anda.',
        failed: 'Gagal mengirim permintaan. Silakan coba lagi.',
        nameRequired: 'Nama wajib diisi',
        communityRequired: 'Nama komunitas atau brand wajib diisi',
        emailInvalid: 'Masukkan alamat email yang valid',
        categoryRequired: 'Pilih kategori event',
      },
    },
    coreValues: {
      label: 'Nilai Inti',
      title: 'Apa yang kami junjung',
      titleLine1: 'Apa yang kami',
      titleLine2: 'junjung',
      titleHighlight: 'dibangun untuk pertumbuhan',
      titleSuffix: '—bukan gatekeeping.',
      rotatingLines: [
        'Terbuka & tanpa batas. Tanpa birokrasi tertutup.',
        'Kredibilitas terverifikasi dengan UX Web2 yang intuitif.',
        'Jaringan di atas platform—Anda adalah pemangku kepentingan.',
      ],
      openBorderless: {
        title: 'Terbuka & Tanpa Batas',
        desc: 'Tanpa birokrasi tertutup. Formulir aplikasi ekosistem selalu terbuka transparan bagi siapa pun yang ingin berkontribusi.',
      },
      onChainCredibility: {
        title: 'Kredibilitas Terverifikasi',
        desc: 'Setiap tiket diamankan sebagai aset digital berkecepatan tinggi di Solana. Bukti kehadiran permanen, anti-pemalsuan, dan tervalidasi sistem.',
      },
      intuitiveWeb2: {
        title: 'UX Web2 Intuitif',
        desc: 'Transaksi instan via GoPay, OVO, atau QRIS. Infrastruktur blockchain berjalan otomatis di backend. Pengguna fokus sepenuhnya pada pengalaman event.',
      },
      networkOverPlatform: {
        title: 'Jaringan di Atas Platform',
        desc: 'Nilai meningkat eksponensial seiring bergabungnya mitra. Anda bukan sekadar konsumen, melainkan pemangku kepentingan ekosistem.',
      },
    },
    roadmap: {
      label: 'Roadmap',
      title: 'Roadmap lini produk',
      titleLine1: 'Roadmap lini',
      titleLine2: 'produk',
      rotatingLines: [
        'Event Hub & Jaringan Ekosistem — sudah live.',
        'Tap In eksekusi lapangan — pilot di Jogja.',
        'Arsitektur crowdfunding — fase riset berjalan.',
      ],
      statusLive: 'Live',
      statusLiveAria: 'Live',
      statusPilot: 'Pilot · Yogyakarta',
      statusPilotAria: 'Pilot di Yogyakarta',
      statusInDevelopment: 'Dalam pengembangan',
      statusInDevelopmentAria: 'Dalam pengembangan',
      statusSoon: 'Segera',
      statusSoonAria: 'Segera hadir',
      pl01: {
        label: 'PL 01: Event Hub & Jaringan Ekosistem',
        title: 'Event Hub & Jaringan Ekosistem',
        status: 'live',
        progress: '100',
        desc: 'Mengelola 50+ event, 20+ mitra event ekosistem, dan memfasilitasi lebih dari 1.200 pengguna aktif.',
      },
      pl02: {
        label: 'PL 02: Tap In — Layanan Eksekusi Lapangan',
        title: 'Tap In — Layanan Eksekusi Lapangan',
        status: 'pilot',
        progress: '80',
        desc: 'Fokus manajemen fisik talkshow, meetup, workshop, dan aktivasi sosial & olahraga di Jogja.',
      },
      pl03: {
        label: 'PL 03: Tiket Berbayar (Hybrid + Gateway Web2)',
        title: 'Tiket Berbayar (Hybrid + Gateway Web2)',
        status: 'development',
        progress: '60',
        desc: 'Integrasi mendalam Midtrans/Xendit untuk minting tiket backend yang mulus.',
      },
      pl04: {
        label: 'PL 04: Crowdfunding Berbasis Komunitas',
        title: 'Crowdfunding Berbasis Komunitas',
        status: 'soon',
        progress: '0',
        desc: 'Fase riset arsitektur fundraising terdesentralisasi yang aman.',
      },
    },
    ctaBand: {
      headline: 'Siap membangun ekosistem event Anda?',
      headlineLine1: 'Siap membangun',
      headlineLine2: 'ekosistem event Anda?',
      eyebrow: 'Gratis untuk bergabung',
      subhead:
        'Gabung network hub kami gratis. Bawa event Anda, kembangkan audiens, dan manfaatkan promosi organik lintas jaringan.',
      rotatingLines: [
        'Gabung network hub kami gratis.',
        'Bawa event Anda. Kembangkan audiens.',
        'Manfaatkan promosi organik lintas ekosistem.',
      ],
      primaryCta: 'Gabung Ekosistem — Gratis Sekarang',
      feeTransparency:
        'Event gratis bebas biaya platform 0%. Event berbayar dikenakan biaya platform flat transparan mirip Loket/Eventbrite tanpa komitmen bulanan.',
    },
    pages: {
      tapIn: {
        metaTitle: 'Tap In — Eksekusi Event Layanan Penuh | Creatix',
        kicker: 'Eksekusi lapangan',
        title: 'Tim lapangan, eksekusi layanan penuh.',
        titleLine1: 'Tim lapangan,',
        titleLine2: 'eksekusi layanan penuh.',
        subtitle:
          'Tim Creatix hadir fisik di Yogyakarta untuk mengeksekusi infrastruktur event kelas atas—mengubah peserta pasif menjadi kontributor aktif.',
        cta: 'Ajukan Eksekusi Tap In',
      },
      roadmap: {
        metaTitle: 'Roadmap Produk | Creatix',
        kicker: 'Roadmap',
        title: 'Membangun ekosistem event Indonesia, fase demi fase.',
        titleLine1: 'Membangun ekosistem event Indonesia,',
        titleLine2: 'fase demi fase.',
        subtitle:
          'Dari event hub yang live, eksekusi Tap In, tiket berbayar, hingga riset crowdfunding komunitas.',
        cta: 'Gabung Ekosistem',
      },
      ecosystem: {
        metaTitle: 'Mitra Ekosistem | Creatix',
        kicker: 'Mitra Ekosistem',
        title: 'Tumbuh bersama jaringan—bukan melawannya.',
        titlePrefix: 'Tumbuh bersama',
        rotatorWords: ['jaringan', 'komunitas', 'brand', 'kreator'],
        titleSuffix: '—bukan melawannya.',
        subtitle:
          'Setiap mitra yang bergabung memperkuat seluruh ekosistem. Promosi silang organik tanpa biaya tambahan. Anda bukan sekadar pengguna—Anda adalah pemangku kepentingan.',
        primaryCta: 'Daftar sebagai Mitra',
        secondaryCta: 'Jelajahi Event',
        infraKicker: 'Infrastruktur Global',
        infraTitle: 'Dibangun di atas rel yang bisa',
        infraHighlight: 'dipercaya',
        partnersKicker: 'Mitra Ekosistem',
        partnersTitle: 'Komunitas yang menggerakkan',
        partnersHighlight: 'setiap event',
        ctaKicker: 'Ekosistem terbuka',
        ctaTitle: 'Jadi mitra ekosistem.',
        ctaBody:
          'Formulir aplikasi ekosistem terbuka transparan bagi siapa saja yang ingin berkontribusi—tanpa birokrasi tertutup.',
        ctaApply: 'Daftar Sekarang',
      },
    },
  },

  // ─── Landing footer (logged-out marketing only) ───────────────
  landingFooter: {
    ariaLabel: 'Footer marketing',
    description: 'Events Hub untuk komunitas. Temukan event, daftar, dapatkan tiket QR, dan check-in — dibuat untuk komunitas dan penyelenggara.',
    platform: 'Platform',
    support: 'Dukungan',
    explore: 'Jelajahi Event',
    calendar: 'Kalender',
    createEvent: 'Buat Event',
    howItWorks: 'Cara Kerjanya',
    tapIn: 'Tap In',
    roadmap: 'Roadmap',
    contact: 'Hubungi Kami',
    privacy: 'Kebijakan Privasi',
    terms: 'Syarat Layanan',
    xAria: 'X (Twitter)',
    instagramAria: 'Instagram',
    emailAria: 'Email',
    copyright: '© 2026 Creatix. Hak cipta dilindungi.',
    tagline: 'Dibuat untuk ekosistem acara.',
  },

  // ─── Beranda (logged-in events feed) ──────────────────────────
  home: {
    greeting: 'Selamat {{period}}, {{name}}',
    greetingSubtitle: 'Berikut yang akan datang untuk Anda',
    greetingPeriod: {
      morning: 'pagi',
      afternoon: 'siang',
      evening: 'malam',
    },
    yourEvents: 'Event Anda',
    yourEventsSubtitle: 'Event yang Anda selenggarakan atau hadiri',
    viewMyEvents: 'Lihat semua',
    discover: 'Jelajahi',
    discoverSubtitle: 'Lihat apa yang sedang dan akan terjadi',
    events: 'Event',
    eventsSubtitle: 'Lihat apa yang sedang dan akan terjadi',
    viewCalendar: 'Lihat Kalender',
    failedToLoad: 'Gagal memuat event. Silakan coba lagi nanti.',
    happeningNow: 'Sedang Berlangsung',
    eventsLive_one: '{{count}} event live',
    eventsLive_other: '{{count}} event live',
    startingSoon: 'Segera Dimulai',
    eventsStarting_one: '{{count}} event akan segera dimulai',
    eventsStarting_other: '{{count}} event akan segera dimulai',
    todayEvents: 'Hari Ini',
    eventsToday_one: '{{count}} event',
    eventsToday_other: '{{count}} event',
    upcomingEvents: 'Event Mendatang',
    upcoming: 'Mendatang',
    showMoreEvents: 'Tampilkan lebih banyak event',
    loadMoreEvents: 'Muat lebih banyak event',
    viewFullCalendar: 'Lihat kalender lengkap',
    noEvents: 'Event tidak ditemukan',
    noUpcomingYet: 'Belum ada event mendatang',
    noEventsSubtitle: 'Jadilah yang pertama membuat event',
    viewAll: 'Lihat semua',
    liveNow: 'Sedang Berlangsung',
    live: 'LIVE',
    inTime: 'Dalam {{time}}',
    timeRemaining: '{{time}} tersisa',
    startsIn: 'Mulai dalam {{time}}',
  },

  // ─── Detail Event ─────────────────────────────────────────────
  event: {
    rsvp: 'RSVP',
    cancelRsvp: 'Batalkan RSVP',
    confirmed: 'Terkonfirmasi',
    pending: 'Menunggu Persetujuan',
    waitlisted: 'Dalam Antrean',
    cancelled: 'Dibatalkan',
    checkedIn: 'Sudah Check-in',
    attending: 'Hadir',
    waitlistPosition: 'Antrean #{{position}}',
    capacity: 'Kapasitas',
    spotsLeft: 'Tersisa {{count}} tempat',
    spotsLeft_other: 'Tersisa {{count}} tempat',
    soldOut: 'Habis Terjual',
    free: 'Gratis',
    inPerson: 'Langsung',
    online: 'Online',
    hybrid: 'Hybrid',
    share: 'Bagikan',
    addToCalendar: 'Tambah ke Kalender',
    viewOnMap: 'Lihat di Peta',
    attendees: 'Peserta',
    schedule: 'Jadwal',
    community: 'Komunitas',
    about: 'Tentang',
    organizer: 'Penyelenggara',
    coHosts: 'Co-host',
    sessions: 'Sesi',
    hostedBy: 'Diselenggarakan oleh',
    live: 'LIVE',
    inTime: 'Dalam {{time}}',
    timeRemaining: '{{time}} tersisa',
    happeningNow: 'Sedang berlangsung',
    startsIn: 'Mulai dalam {{time}}',
    locationAfterRsvp: 'Lokasi tersedia setelah RSVP',
    hybridAttendance: '{{inPerson}} langsung · {{online}} online',
    attendee_one: '{{count}} peserta',
    attendee_other: '{{count}} peserta',
    attendeeWithCapacity: '{{count}} / {{capacity}} menghadiri',
    ticketsSold: 'Tiket Terjual',
    rsvps: 'RSVP',
    viewEventAria: 'Lihat {{title}}',
    rsvpToEvent: 'RSVP ke event ini',
    spotsFilled: '{{count}} dari {{capacity}} tempat terisi',
    peopleGoing: '{{count}} orang hadir',
    rsvpNow: 'RSVP Sekarang',
    ticketsNotAvailable: 'Tiket belum tersedia untuk event ini.',
    eventDetails: 'Detail Event',
    endsAt: 'Berakhir: {{date}}',
    joinLink: 'Tautan Gabung',
    person: 'orang',
    people: 'orang',
    eventCancelled: 'Event Dibatalkan',
    collaborators: 'Kolaborator',
    collaborator: 'Kolaborator',
    joinMeeting: 'Gabung Rapat',
    linkAvailableBeforeStart: 'Tersedia 1 jam sebelum mulai',
    linkTba: 'Tautan akan diumumkan',
    when: 'Kapan',
    where: 'Di mana',
    venueTba: 'Tempat TBD',
    locationAfterConfirmation: 'Lokasi tersedia setelah konfirmasi',
    fullAddressAfterRsvp: 'Alamat lengkap tersedia setelah konfirmasi RSVP',
    onlineAccess: 'Akses Online',
    goingCount: '{{count}} hadir',
    totalSpots: '{{count}} total tempat',
    openEntry: 'Masuk Terbuka',
    attendingCount: '{{count}} menghadiri',
    shareText: 'Lihat event ini: {{title}}',
    showQrCode: 'Tampilkan Kode QR',
    shareOnX: 'Bagikan di X',
    shareOnFacebook: 'Bagikan di Facebook',
    shareOnLinkedIn: 'Bagikan di LinkedIn',
    copyLink: 'Salin Tautan',
    qrCodeTitle: 'Kode QR Event',
    qrCodeAlt: 'Kode QR Event',
    qrCodeDesc: 'Pindai kode ini untuk membagikan event ini dengan cepat.',
    downloadQr: 'Unduh QR',
    downloadQrHint: 'Simpan sebagai SVG untuk kualitas tinggi',
    selectTicket: 'Pilih Tiket Anda',
    selectTicketDesc: 'Pilih jenis tiket untuk melanjutkan.',
    availableTickets: 'Tiket Tersedia',
    chooseTicketDesc: 'Pilih jenis tiket dan amankan tempat Anda',
    hybridBanner: 'Ini adalah event hybrid',
    hybridBannerDesc: 'Hadir langsung di tempat ATAU gabung online dari mana saja.',
    whatDoesThisMean: 'Apa maksudnya?',
    ticketsComingSoon: 'Tiket Segera Hadir',
    ticketsComingSoonDesc: 'Host belum merilis tiket untuk event ini. Cek kembali nanti!',
    sessionCount_one: '{{count}} sesi',
    sessionCount_other: '{{count}} sesi',
    viewFullSchedule: 'Lihat jadwal lengkap',
    manageProgramme: 'Kelola Program',
    viewSchedule: 'Lihat Jadwal',
    viewCommunity: 'Lihat Komunitas →',
    xVerified: 'X terverifikasi',
    xLinked: 'X terhubung',
    getTicket: 'Dapatkan Tiket',
    getTierCta: 'Dapatkan {{tierName}} · {{type}} — {{price}}',
    gallery: 'Galeri',
    promoImageAlt: 'Gambar promosi {{title}}',
    previousImageAria: 'Gambar sebelumnya',
    nextImageAria: 'Gambar berikutnya',
  },

  // ─── Buat Event ───────────────────────────────────────────────
  createEvent: {
    title: 'Buat Event',
    basicInfo: 'Info Dasar',
    media: 'Media',
    schedule: 'Jadwal & Lokasi',
    tickets: 'Tiket',
    registration: 'Pendaftaran',
    eventTitle: 'Judul Event',
    eventTitlePlaceholder: 'Beri nama yang menarik untuk event Anda',
    summary: 'Ringkasan',
    summaryPlaceholder: 'Deskripsi singkat (10-200 karakter)',
    description: 'Deskripsi',
    descriptionPlaceholder: 'Ceritakan tentang event Anda kepada peserta...',
    categories: 'Kategori',
    coverImage: 'Gambar Sampul',
    displayPicture: 'Foto Tampilan',
    startDate: 'Tanggal Mulai',
    endDate: 'Tanggal Selesai',
    timezone: 'Zona Waktu',
    locationType: 'Jenis Lokasi',
    venue: 'Tempat',
    venuePlaceholder: 'Nama atau alamat tempat',
    city: 'Kota',
    country: 'Negara',
    onlineLink: 'Tautan Online',
    capacity: 'Kapasitas',
    onlineCapacity: 'Kapasitas Online',
    waitlist: 'Aktifkan Daftar Tunggu',
    approvalRequired: 'Memerlukan Persetujuan',
    publish: 'Publikasikan',
    saveDraft: 'Simpan sebagai Draf',
    next: 'Lanjut',
    previous: 'Sebelumnya',
    addTicketTier: 'Tambah Jenis Tiket',
    tierName: 'Nama Jenis',
    tierPrice: 'Harga',
    tierQuantity: 'Jumlah',
    steps: {
      basicInfo: 'Informasi Dasar',
      basicInfoShort: 'Info Dasar',
      media: 'Media Event',
      mediaShort: 'Media',
      schedule: 'Jadwal',
      scheduleShort: 'Jadwal',
      location: 'Lokasi',
      locationShort: 'Lokasi',
      pricing: 'Harga',
      pricingShort: 'Harga',
      tickets: 'Tiket & Pendaftaran',
      ticketsShort: 'Tiket',
      review: 'Tinjau & Publikasikan',
      reviewShort: 'Tinjau',
    },
    requiredMark: '*',
    categoriesHint: 'Pilih 1-3 kategori.',
    loadingCategories: 'Memuat kategori...',
    titleLengthHint: 'Min 5, Maks 50 karakter.',
    summaryLengthHint: 'Min 10, Maks 200 karakter.',
    descriptionLengthHint: 'Min 50 karakter.',
    location: 'Lokasi',
    eventFormat: 'Format Event',
    inPersonDesc: 'Selenggarakan event di tempat fisik',
    onlineDesc: 'Selenggarakan pertemuan virtual',
    hybridDesc: 'Langsung dan online',
    locationSearch: 'Pencarian Lokasi',
    locationSearchHint: 'Cari tempat atau alamat...',
    address: 'Alamat',
    notSet: 'Belum diatur',
    programmeToggle: 'Jadwal Event / Program',
    programmeToggleDesc: 'Aktifkan program multi-sesi untuk event Anda.',
    communityScheduleDesc: 'Izinkan peserta yang check-in membuat dan hosting side event selama event Anda.',
    onlineLinkPlaceholder: 'https://...',
    addressMapVenuePlaceholder: 'mis. Tampi Bumi',
    addressMapDistrictPlaceholder: 'mis. Pereng, Bumirejo, Lendah',
    addressMapCityPlaceholder: 'mis. Jakarta',
    addressMapCountryPlaceholder: 'mis. Indonesia',
    addressMapFullPlaceholder: 'Masukkan alamat lengkap (mis. Jl. Utama 123, New York, NY 10001)',
    generateLinkTitle: 'Buat tautan rapat otomatis',
    generateLink: 'Buat Tautan',
    hybridFull: 'Hybrid (Langsung + Online)',
    noneSelected: 'Tidak ada yang dipilih',
    coverPreviewAlt: 'Pratinjau sampul',
    notUploaded: 'Belum diunggah',
    avatarPreviewAlt: 'Pratinjau avatar',
    format: 'Format',
    pricing: 'Harga',
    eventType: 'Tipe Event',
    freeRsvp: 'RSVP Gratis',
    paidTicketed: 'Berbayar / Tiket',
    ticketsAndRegistration: 'Tiket & Pendaftaran',
    tierDefaultName: 'Tingkat {{n}}',
    unlimited: 'Tak Terbatas',
    spots: '{{count}} tempat',
    totalCapacity: 'Total Kapasitas',
    visibility: 'Visibilitas',
    public: 'Publik',
    private: 'Pribadi',
    publishState: 'Status Publikasi',
    prePublishChecklist: 'Daftar Periksa Pra-publikasi',
    checklistTitle: 'Event memiliki judul',
    checklistSummary: 'Ringkasan disediakan',
    checklistStartFuture: 'Tanggal mulai di masa depan',
    checklistLocation: 'Detail lokasi lengkap',
    checklistTierArt: 'Semua jenis tiket memiliki gambar',
    datesLockedToday: 'Tidak dapat mengubah tanggal/waktu untuk event yang dimulai hari ini',
    eventPricing: 'Harga Event',
    pricingQuestion: 'Apakah ini event gratis atau berbayar?',
    freeEvent: 'Event Gratis',
    freeEventDesc: 'Peserta dapat RSVP gratis',
    paidEvent: 'Event Berbayar',
    paidEventDesc: 'Jual tiket dengan harga kustom',
    collectRegistrationInfo: 'Kumpulkan informasi pendaftaran tambahan',
    collectRegistrationInfoDesc: 'Ajukan pertanyaan tambahan kepada tamu saat mereka mendaftar.',
    registrationOptions: 'Opsi pendaftaran',
    personalInformation: 'Informasi Pribadi',
    name: 'Nama',
    fromProfile: 'Dari profil',
    web3Identity: 'Identitas Web3',
    solanaAddress: 'Alamat Solana',
    customQuestions: 'Pertanyaan Kustom',
    addQuestion: 'Tambah Pertanyaan',
    noCustomQuestions: 'Tidak ada pertanyaan kustom',
    questionRequired: '• Wajib',
    enableToCollectFields: 'Aktifkan kotak centang di atas untuk mengumpulkan kolom ini saat tamu mendaftar.',
    phone: 'Telepon',
    collectPhoneAria: 'Kumpulkan nomor telepon',
    startDateTime: 'Tanggal & Waktu Mulai',
    endDateTime: 'Tanggal & Waktu Selesai',
  },

  // ─── Kelola Event ─────────────────────────────────────────────
  manage: {
    overview: 'Ikhtisar',
    attendees: 'Peserta',
    checkIn: 'Check-in',
    sessions: 'Sesi',
    community: 'Komunitas',
    analytics: 'Analitik',
    settings: 'Pengaturan',
    collaborators: 'Kolaborator',
    totalAttendees: 'Total Peserta',
    checkedIn: 'Sudah Check-in',
    pending: 'Menunggu',
    waitlisted: 'Daftar Tunggu',
    searchAttendees: 'Cari peserta...',
    exportCsv: 'Ekspor CSV',
    approve: 'Setujui',
    reject: 'Tolak',
    checkInManually: 'Check In',
    removeAttendee: 'Hapus',
    inviteAttendee: 'Undang',
    addCollaborator: 'Tambah Kolaborator',
    editEvent: 'Edit Event',
    cancelEvent: 'Batalkan Event',
    deleteEvent: 'Hapus Event',
  },

  // ─── Tiket ────────────────────────────────────────────────────
  tickets: {
    myTickets: 'Tiket Saya',
    ticket: 'Tiket',
    viewTicket: 'Lihat Tiket',
    downloadTicket: 'Unduh',
    qrCode: 'Kode QR',
    scanToCheckIn: 'Scan untuk Check In',
    ticketId: 'ID Tiket',
    purchasedAt: 'Dibeli',
    redeemedAt: 'Digunakan',
    nftTicket: 'Tiket NFT',
    withdrawNft: 'Tarik ke Wallet',
    withdrawing: 'Menarik...',
    withdrawn: 'Sudah Ditarik',
    viewOnExplorer: 'Lihat di Explorer',
    generateQr: 'Buat QR',
    refreshQr: 'Perbarui',
    tierArtAlt: 'Gambar tiket {{name}}',
    xOfYAvailable: '{{available}} dari {{total}} tersedia',
    saleStarts: 'Penjualan mulai: {{date}}',
    saleEnds: 'Penjualan berakhir: {{date}}',
    saleEnded: 'Penjualan Berakhir',
    saleNotStarted: 'Penjualan Belum Dimulai',
    soldOut: 'Habis Terjual',
    buyTickets: 'Beli Tiket',
    backToEvent: 'Kembali ke Event',
    scanEntryCode: 'Pindai kode masuk',
    viewPoaNft: 'Lihat PoA NFT ↗',
    cancelledMessage: 'Tiket ini telah dibatalkan.',
    inPersonalWallet: 'Tiket ada di dompet pribadi Anda',
    custodyDescription: 'Tiket ini disimpan dengan aman di aplikasi. Tarik ke dompet Solana Anda saat siap.',
    withdrawToWallet: 'Tarik ke {{address}}',
    withdrawalSuccess: 'Penarikan berhasil dimulai!',
    withdrawalFailed: 'Penarikan gagal. Silakan coba lagi.',
    proofOfAttendance: 'Bukti kehadiran',
    defaultEventTitle: 'Event komunitas',
    noTicketsFound: 'Tiket tidak ditemukan',
    noUpcoming: 'Tidak ada tiket mendatang',
    noPast: 'Tidak ada tiket sebelumnya',
    filteredCount: '{{filtered}} dari {{total}} tiket',
    viewAllCount: 'Lihat semua {{count}} tiket',
    tierSaved: 'Tingkat tiket disimpan',
    failedToSaveTier: 'Gagal menyimpan tingkat',
    invalidCheckInCode: 'Kode check-in tidak valid atau kedaluwarsa',
    attendeeCheckedIn: 'Peserta berhasil check-in',
    poaTransferred: 'POA ditransfer ke dompet Anda',
    tierNameRequired: 'Nama tingkat wajib diisi',
    connectWalletFirst: 'Harap hubungkan dompet Anda terlebih dahulu',
    signInToPurchase: 'Harap masuk untuk membeli tiket',
    failedToPurchaseTickets: 'Gagal membeli tiket',
    tierNamePlaceholder: 'mis., Umum, VIP, Early Bird',
    tierDescriptionPlaceholder: 'Deskripsi singkat isi tingkat ini',
    unlimitedPlaceholder: 'Tak terbatas',
    pricePlaceholder: '0.00',
  },

  // ─── Profil ───────────────────────────────────────────────────
  profile: {
    editTitle: 'Edit Profil',
    save: 'Simpan',
    saving: 'Menyimpan...',
    cancel: 'Batal',
    loading: 'Memuat...',
    username: 'Nama pengguna',
    usernameHint: 'Harus 3–30 karakter. Huruf, angka, tanda hubung, dan garis bawah saja.',
    usernameAvailable: 'Nama pengguna tersedia',
    usernameTaken: 'Nama pengguna sudah dipakai',
    email: 'Email',
    displayName: 'Nama tampilan',
    location: 'Lokasi',
    bio: 'Bio',
    bioPlaceholder: 'Ceritakan tentang diri Anda...',
    usernamePlaceholder: 'nama pengguna',
    twitterHandlePlaceholder: 'handle',
    website: 'Situs web',
    twitter: 'X / Twitter',
    github: 'GitHub',
    organizedEvents: 'Acara yang Diselenggarakan',
    stats: {
      organized: 'Acara diselenggarakan',
      attending: 'Acara dihadiri',
      tickets: 'Tiket',
    },
    walletAddress: 'Dompet',
    unlinkXFailed: 'Gagal memutuskan akun X',
    redirecting: 'Mengarahkan ke masuk...',
    bannerAlt: 'Banner {{username}}',
    unlinkXTitle: 'Putuskan Akun X',
    unlinkXDescription: 'Yakin ingin memutuskan akun X Anda? Anda tidak akan bisa menampilkan status verifikasi X lagi.',
    tabs: {
      events: 'Acara Saya',
      tickets: 'Tiket',
      notifications: 'Notifikasi',
      settings: 'Pengaturan',
    },
    profileMedia: 'Media Profil',
    bannerImage: 'Gambar Banner',
    avatarImage: 'Gambar Avatar',
    mediaHint: 'Gambar berkualitas membantu profil Anda menonjol. Kami mengoptimalkannya untuk pemuatan cepat.',
    notificationPreferences: 'Preferensi notifikasi',
    notificationPreferencesHint: 'Pilih notifikasi email yang ingin Anda terima.',
    manageEmailNotifications: 'Kelola notifikasi email',
    connectedAccounts: 'Akun Terhubung',
    deleteAccount: 'Hapus akun',
    deleteAccountTitle: 'Hapus akun Anda',
    deleteAccountDescription: 'Tindakan ini permanen. Profil, acara, RSVP, tiket, dan notifikasi Anda akan dihapus.',
    deleteAccountConfirmLabel: 'Ketik nama pengguna Anda untuk konfirmasi',
    deleteAccountConfirmButton: 'Hapus akun saya',
    deleteAccountCancel: 'Batal',
    notFound: 'Profil tidak ditemukan',
    notFoundTitle: 'Profil tidak ditemukan',
    notFoundDescription: 'Profil ini mungkin tidak ada atau nama pengguna salah.',
    privateTitle: 'Profil ini bersifat pribadi',
    privateDescription: 'Pemilik telah membatasi siapa yang dapat melihat profil ini.',
    editProfile: 'Edit profil',
    editShort: 'Edit',
    avatarAlt: 'Avatar {{username}}',
    xVerified: 'X terverifikasi',
    xLinked: 'X tertaut',
    viewOnX: 'Lihat di X',
    rsvpCount: '{{count}} hadir',
    rsvpConfirmed: 'Dikonfirmasi',
    joined: 'Bergabung',
    attendingEvents: 'Acara yang Dihadiri',
    searchPlaceholder: 'Cari berdasarkan nama pengguna atau nama...',
    searchNoResults: 'Pengguna tidak ditemukan',
    searchMinChars: 'Ketik minimal 2 karakter untuk mencari',
    searchResultUser: 'Pengguna',
    searchInitial: 'P',
    language: 'Bahasa',
    dangerZone: 'Zona Berbahaya',
    uploadAvatar: 'Unggah Foto',
    eventsOrganized: 'Event Diselenggarakan',
    eventsAttended: 'Event Dihadiri',
    dataExport: {
      title: 'Ekspor data Anda',
      description: 'Unduh salinan JSON yang dapat dibaca mesin dari semua data pribadi yang kami simpan. Pemrosesan biasanya memakan 5–10 menit.',
      request: 'Ekspor data saya',
      requesting: 'Meminta ekspor…',
      preparing: 'Menyiapkan ekspor Anda…',
      requestedAt: 'Diminta {{date}}',
      readyHint: 'Ekspor Anda siap. Unduh sebelum {{date}}.',
      download: 'Unduh data saya',
      failed: 'Ekspor Anda gagal. Silakan coba lagi.',
      tryAgain: 'Coba lagi',
      expired: 'Ekspor sebelumnya telah kedaluwarsa.',
      requestNew: 'Minta ekspor baru',
      beforeDelete: 'Pertimbangkan untuk mengekspor data Anda sebelum menghapus akun.',
      beforeDeleteLink: 'Ke ekspor data',
    },
    providers: {
      google: 'Akun Google',
      apple: 'Akun Apple',
      x: 'Akun X',
      wallet: 'Dompet',
      linked: 'Terhubung',
      notLinked: 'Belum terhubung',
      unlink: 'Putuskan',
      unlinkXTitle: 'Putuskan Akun X',
      unlinkXDescription: 'Yakin ingin memutuskan akun X Anda?',
      unlinkGoogleTitle: 'Putuskan Akun Google',
      unlinkGoogleDescription: 'Yakin ingin memutuskan akun Google Anda?',
    },
    errors: {
      updateFailed: 'Gagal memperbarui profil',
      deleteFailed: 'Gagal menghapus akun',
      searchFailed: 'Gagal mencari profil',
      unlinkFailed: 'Gagal memutuskan akun',
    },
  },

  // ─── Pengaturan ───────────────────────────────────────────────
  settings: {
    connectedAccounts: {
      title: 'Akun Terhubung',
      description: 'Kelola metode masuk yang terhubung ke akun Creatix Anda.',
      linkProvider: 'Hubungkan',
      unlinkProvider: 'Putuskan',
      unlinkConfirm: 'Putuskan akun ini?',
      unlinkWarning:
        'Yakin ingin memutuskan {{provider}}? Anda memerlukan metode masuk lain untuk mengakses akun.',
      unlinkWarningGeneric:
        'Yakin? Anda memerlukan metode masuk lain untuk mengakses akun.',
      providerLinked: '{{provider}} berhasil dihubungkan',
      providerAlreadyLinked:
        'Akun ini sudah terhubung ke profil Creatix lain. Masuk dengan penyedia tersebut.',
      cannotUnlinkLast: 'Tidak dapat memutuskan metode autentikasi terakhir',
      linked: 'Terhubung',
      notLinked: 'Belum terhubung',
      onlyMethod: 'Satu-satunya metode masuk',
      unlinked: 'Akun diputuskan',
      linkFailed: 'Gagal menghubungkan akun',
      loadFailed: 'Gagal memuat akun terhubung',
      linkWalletTitle: 'Hubungkan dompet Solana',
      linkWalletDescription: 'Tandatangani pesan dengan dompet Anda untuk memverifikasi kepemilikan.',
      linkWalletConnect: 'Hubungkan ekstensi dompet Solana untuk melanjutkan.',
      providers: {
        google: 'Google',
        apple: 'Apple',
        x: 'X',
        wallet: 'Dompet Solana',
      },
    },
  },

  // ─── Notifikasi ───────────────────────────────────────────────
  notifications: {
    title: 'Notifikasi',
    markAllRead: 'Tandai semua telah dibaca',
    noNotifications: 'Belum ada notifikasi',
    rsvpConfirmed: 'RSVP Anda terkonfirmasi',
    rsvpWaitlisted: 'Anda masuk daftar tunggu',
    rsvpPromoted: 'Anda telah dikonfirmasi dari daftar tunggu',
    eventReminder: 'Event akan segera dimulai',
    checkedIn: 'Berhasil check-in',
    nftMinted: 'NFT POA Anda telah diminting',
    emailPreferences: 'Preferensi Email',
    pushEnabled: 'Notifikasi push diaktifkan',
    enablePush: 'Aktifkan Notifikasi Push',
    delete: 'Hapus notifikasi',
    empty: 'Belum ada notifikasi',
    invitationTitle: 'Undangan: {{eventTitle}}',
    invitedYou: '{{inviterName}} mengundang Anda',
    criticalUpdates: 'Pembaruan penting',
    criticalUpdatesDesc: 'Acara dibatalkan, dijadwalkan ulang, atau perubahan besar; undangan; kolaborator ditambah/dihapus',
    myActivity: 'Aktivitas saya',
    myActivityDesc: 'Konfirmasi RSVP, persetujuan, penolakan; tiket siap; konfirmasi check-in',
    reminders: 'Pengingat',
    remindersDesc: '24 jam dan 1 jam sebelum acara dimulai',
    organizerActivity: 'Aktivitas penyelenggara',
    organizerActivityDesc: 'RSVP baru, RSVP dibatalkan, undangan diterima (untuk acara yang Anda selenggarakan)',
    sessionUpdates: 'Pembaruan sesi',
    sessionUpdatesDesc: 'Sesi dibatalkan, dijadwalkan ulang, atau dihapus',
    communityEvents: 'Acara komunitas',
    communityEventsDesc: 'RSVP baru ke acara komunitas Anda; RSVP dibatalkan',
    saved: 'Preferensi notifikasi disimpan',
    saveFailed: 'Gagal menyimpan',
    backToProfile: 'Kembali ke profil',
    pageTitle: 'Notifikasi',
    pageDescription: 'Kelola pusat notifikasi dan preferensi email Anda.',
    notificationCenter: 'Pusat notifikasi',
    browserPush: 'Notifikasi push browser',
    browserPushDesc: 'Dapatkan pemberitahuan saat ada aktivitas baru, bahkan saat tab tertutup.',
    pushDisabled: 'Notifikasi push dinonaktifkan',
    pushDisabledError: 'Gagal menonaktifkan',
    pushEnabledError: 'Gagal mengaktifkan',
    disable: 'Nonaktifkan',
    enable: 'Aktifkan',
    enabled: 'Diaktifkan',
    disabled: 'Dinonaktifkan',
    emailNotifications: 'Notifikasi email',
    emailDesc: 'Pilih email yang ingin Anda terima. Anda dapat mengubahnya kapan saja.',
    deliveryChannel: 'Saluran pengiriman',
    deliveryChannelDesc: 'Ke mana notifikasi dikirim. Umpan di aplikasi dan push browser selalu aktif.',
    channelEmail: 'Email',
    channelWhatsapp: 'WhatsApp',
    channelBoth: 'Keduanya',
    whatsappNumber: 'Nomor WhatsApp',
    whatsappNumberPlaceholder: '+62...',
    sendCode: 'Kirim kode',
    sending: 'Mengirim...',
    codeSent: 'Kode dikirim ke WhatsApp Anda.',
    enterCode: 'Masukkan kode 6 digit',
    verify: 'Verifikasi',
    verifying: 'Memverifikasi...',
    verified: 'Terverifikasi',
    removeNumber: 'Hapus nomor',
    whatsappVerifyRequired: 'Verifikasi nomor WhatsApp Anda dahulu',
    saving: 'Menyimpan...',
    savePreferences: 'Simpan preferensi',
    cancel: 'Batal',
    unsubscribeFooter: 'Untuk berhenti menerima semua email, gunakan tautan "Berhenti berlangganan" di email Creatix mana pun.',
  },

  // ─── Check-in ─────────────────────────────────────────────────
  checkIn: {
    title: 'Check-in',
    scanQr: 'Scan Kode QR',
    enterCode: 'Masukkan Kode',
    selfCheckIn: 'Check-in Mandiri',
    checkInCode: 'Kode Check-in',
    codePlaceholder: 'Masukkan kode 6 digit',
    selfCheckInCodePlaceholder: '000 000',
    checkInSuccess: 'Check-in berhasil!',
    alreadyCheckedIn: 'Sudah check-in',
    invalidCode: 'Kode tidak valid',
    nftMinting: 'Minting NFT POA Anda...',
    nftMinted: 'NFT POA berhasil diminting!',
    scanAnother: 'Scan Lagi',
    totalCheckedIn: '{{count}} sudah check-in',
    failed: 'Gagal check in',
    signInTitle: 'Masuk untuk check in',
    signInDesc: 'Anda harus masuk untuk check in di tempat acara.',
    signIn: 'Masuk',
    checkedIn: 'Anda sudah check in!',
    checkedInDesc: 'Anda sekarang dapat membuat dan menghadiri event komunitas selama acara ini.',
    viewEvent: 'Lihat event',
    checkInFailed: 'Check-in gagal',
    checkedInShort: 'Sudah check-in',
    checkInSuccessTitle: 'Check-in Berhasil',
    userCheckedIn: '{{username}} berhasil check-in!',
    ticketAlreadyUsed: 'Tiket sudah digunakan!',
    ticketNotFoundForEvent: 'Tiket tidak ditemukan untuk event ini',
    failedCheckInAttendee: 'Gagal check-in peserta',
    failedProcessTicket: 'Gagal memproses tiket',
    failedSelfCheckIn: 'Gagal check-in',
    failedLoadQr: 'Gagal memuat kode QR',
    backToEvent: 'Kembali ke event',
    checkingIn: 'Memeriksa...',
    redirecting: 'Mengarahkan...',
    codeCopiedDesc: 'Kode check-in disalin ke clipboard',
    errorGeneratingCode: 'Gagal membuat kode',
    failedToFetchCheckInCode: 'Gagal mengambil kode check-in',
    eventCheckInCode: 'Kode Check-in Event',
    clickToCopy: 'Klik untuk menyalin',
    refreshingIn: 'Memperbarui dalam {{seconds}}d',
    selfCheckInCode: 'Kode Check-in Mandiri',
    checkInQrAria: 'Kode QR Check-in Event',
    codeRefreshesIn: 'Kode diperbarui dalam {{seconds}} detik',
    scanQrTitle: 'Pindai untuk Check-in',
    scanQrDesc: 'Arahkan kamera ke kode QR untuk memverifikasi kehadiran Anda.',
  },

  // ─── RSVP ────────────────────────────────────────────────────
  rsvp: {
    youreIn: 'Anda berhasil!',
    spotConfirmed: 'Tempat Anda telah dikonfirmasi',
    requestSent: 'Permintaan terkirim',
    organizerReview: 'Penyelenggara akan meninjau jawaban pendaftaran Anda',
    organizerReviewRequest: 'Penyelenggara akan meninjau permintaan Anda',
    addedToWaitlist: 'Ditambahkan ke daftar tunggu',
    failedToAttend: 'Gagal hadir',
    attendanceCancelled: 'Kehadiran dibatalkan',
    failedToCancel: 'Gagal membatalkan kehadiran',
    mustBeLoggedIn: 'Anda harus masuk untuk membatalkan kehadiran.',
    cancelRequestConfirm: 'Yakin ingin membatalkan permintaan kehadiran Anda?',
    leaveWaitlistConfirm: 'Yakin ingin meninggalkan daftar tunggu? Anda akan kehilangan posisi Anda.',
    cancelAttendanceConfirm: 'Yakin ingin membatalkan kehadiran Anda?',
    cancelRequestTitle: 'Batalkan Permintaan?',
    leaveWaitlistTitle: 'Tinggalkan Daftar Tunggu?',
    cancelAttendanceTitle: 'Batalkan Kehadiran?',
    back: 'Kembali',
    canceling: 'Membatalkan...',
    confirm: 'Konfirmasi',
    yourTicketQr: 'Kode QR Tiket Anda',
    ticketQrDesc: 'Tunjukkan kode QR ini di pintu masuk acara.',
    qrAutoRefresh: 'Kode QR akan diperbarui secara otomatis saat akan kedaluwarsa',
    close: 'Tutup',
    loading: 'Memuat...',
    eventCancelled: 'Acara Dibatalkan',
    checkedInAs: 'Check in sebagai {{otherTypeLabel}}',
    attendingAs: 'Hadir {{otherTypeLabel}}',
    pendingApprovalAs: 'Menunggu persetujuan untuk {{otherTypeLabel}}',
    onWaitlistAs: 'Dalam daftar tunggu untuk {{otherTypeLabel}}',
    switching: 'Mengganti...',
    switchTo: 'Ganti ke {{thisTypeLabel}}',
    checkIn: 'Check In',
    ticket: 'Tiket',
    pendingApproval: 'Menunggu Persetujuan',
    waitlistPosition: 'Anda nomor #{{position}} dalam daftar tunggu',
    onWaitlist: 'Anda dalam daftar tunggu',
    leaving: 'Meninggalkan...',
    leaveWaitlist: 'Tinggalkan daftar tunggu',
    eventEnded: 'Acara Berakhir',
    attend: 'Hadir',
    answerQuestions: 'Jawab pertanyaan & minta untuk hadir',
    phonePlaceholder: '+1 234 567 8900',
    walletPlaceholder: '5eykt4...',
    requestToAttend: 'Minta untuk Hadir',
    joinWaitlist: 'Gabung Daftar Tunggu',
    joining: 'Bergabung...',
    attending: 'Hadir...',
    chooseHowToAttend: 'Pilih cara hadir',
    hybridDesc: 'Ini adalah acara hybrid. Silakan pilih tipe kehadiran Anda untuk melanjutkan.',
    joinInPerson: 'Hadir Langsung',
    inPersonDesc: 'Hadir di tempat fisik',
    joinOnline: 'Hadir Online',
    onlineDesc: 'Hadir melalui tautan virtual',
    cancel: 'Batal',
    ticketGenerationSlow: 'Pembuatan tiket lebih lama dari perkiraan.',
    retry: 'Coba lagi',
    generatingTicket: 'Tiket Anda sedang dibuat...',
    warning: 'Peringatan',
    waitlistWarning: 'Daftar tunggu aktif. Tempat Anda akan segera diberikan ke orang berikutnya dalam daftar tunggu. Anda kemungkinan tidak bisa mendapatkannya kembali.',
    capacityWarning: 'Acara ini sudah penuh. Orang lain dapat mengambil tempat Anda segera.',
    lostWaitlistSpot: 'Anda akan kehilangan posisi Anda.',
    clarityTitle: 'Memilih Cara Hadir',
    clarityDesc: 'Event hybrid ini menawarkan dua cara hadir. Pilih opsi yang paling cocok untuk Anda.',
    inPersonAttendance: 'Kehadiran Langsung',
    attendAtVenue: 'Hadir di {{venue}}',
    qrForVenueCheckIn: 'Terima kode QR untuk check-in di tempat',
    onlineAttendance: 'Kehadiran Online',
    joinViaVideo: 'Gabung melalui tautan video dari mana saja',
    checkInAfterMeeting: 'Setelah bergabung rapat, kembali ke halaman event ini untuk check-in',
    checkInCodeInstructions: 'Masukkan kode check-in dari host selama sesi online',
    gotIt: 'Mengerti',
    failedToRsvp: 'Gagal RSVP',
    rsvpCancelledToast: 'RSVP dibatalkan',
    rsvpApproved: 'RSVP disetujui',
    rsvpRejected: 'RSVP ditolak',
    failedToApproveRsvp: 'Gagal menyetujui RSVP',
    failedToRejectRsvp: 'Gagal menolak RSVP',
    attendanceTypeUpdated: 'Tipe kehadiran diperbarui',
    switchedToInPerson: 'Beralih ke hadir langsung',
    switchedToOnline: 'Beralih ke online',
    failedToSwitchAttendanceType: 'Gagal mengubah tipe kehadiran',
    attendeeRemoved: 'Peserta dihapus',
    failedToRemoveAttendee: 'Gagal menghapus peserta',
    failedToSaveRegistrationConfig: 'Gagal menyimpan konfigurasi pendaftaran',
  },

  // ─── Event Komunitas ──────────────────────────────────────────
  community: {
    title: 'Event Komunitas',
    createEvent: 'Buat Event Komunitas',
    hostedBy: 'Diselenggarakan oleh',
    attendees: '{{count}} hadir',
    rsvp: 'RSVP',
    noEvents: 'Belum ada event komunitas.',
    noEventsSubtitle: 'Jadilah yang pertama membuat event komunitas',

    // Jadwal Komunitas
    notEnabled: 'Jadwal komunitas tidak diaktifkan',
    notEnabledDesc: 'Event ini tidak memiliki jadwal komunitas.',
    backToEvent: 'Kembali ke event',
    schedule: 'Jadwal Komunitas',
    scanQrInfo: 'Scan QR check-in di venue untuk membuat atau RSVP ke event komunitas.',
    openCheckIn: 'Buka halaman check-in',
    signInInfo: 'Masuk dan check-in di venue untuk membuat atau RSVP ke event komunitas.',
    signIn: 'Masuk',
    hostSideEvent: 'Host event sampingan',
    noEventsYet: 'Belum ada event komunitas.',
    beFirst: 'Jadilah yang pertama membuatnya',

    // Kartu Event Komunitas
    showMyQr: 'Tampilkan QR saya',
    myCheckInQr: 'QR check-in saya',
    showQrDesc: 'Tunjukkan ini ke host untuk mendapatkan NFT Anda.',
    youreGoing: 'Anda akan hadir!',
    rsvpCancelled: 'RSVP dibatalkan',
    atCapacity: 'Event sudah penuh',
    nft: 'NFT',
    claimed: 'Diklaim',
    tbd: 'TBD',
    goingCapacity: '{{rsvpCount}}/{{capacity}} hadir',
    goingCount: '{{rsvpCount}} hadir',
    byUser: 'oleh @{{username}}',
    claimNft: 'Klaim NFT Anda \u2192',
    edit: 'Edit',
    checkedIn: 'Sudah check-in',
    cancel: 'Batal',
    going: 'Hadir',
    failedToLoadQr: 'Gagal memuat QR',
    failedToUpdateRsvp: 'Gagal memperbarui RSVP',

    // Admin Host Event Komunitas
    invalidQr: 'QR tidak valid \u2013 scan QR check-in peserta',
    alreadyClaimed: 'Sudah diklaim',
    alreadyClaimedDesc: 'Peserta sudah memiliki NFT',
    checkedInNft: 'Check-in berhasil!',
    nftClaimed: 'NFT berhasil diklaim',
    manageCheckIn: 'Kelola check-in',
    checkInOptions: 'Opsi check-in',
    checkInOptionsDesc: 'Pilih cara check-in peserta untuk mendapatkan NFT bukti kehadiran.',
    qrForGuests: 'QR untuk tamu scan',
    getCheckInQr: 'Dapatkan QR check-in',
    checkInQr: 'QR Check-in',
    checkInQrDesc: 'Tampilkan ini di event Anda. Peserta scan untuk mengklaim NFT.',
    scanAttendeeQr: 'Scan QR peserta',
    openScanner: 'Buka pemindai',
    scannerDesc: 'Peserta menunjukkan "QR check-in saya" \u2013 Anda memindainya.',
    scannerTitle: 'Scan QR peserta',
    scannerTitleDesc: 'Arahkan kamera ke kode QR check-in peserta.',
    checkInByUsername: 'Check-in berdasarkan username',
    searchUsername: 'Cari @username...',
    typeToSearch: 'Ketik 2+ karakter untuk mencari',
    noMatchingAttendees: 'Tidak ada peserta yang cocok',
    checkIn: 'Check in',
    failedToCheckIn: 'Gagal check in',
    coverImageAlt: 'Gambar sampul untuk {{title}}',
    userAvatarAlt: 'Avatar {{username}}',
    proofOfAttendance: 'Bukti kehadiran',
    defaultEventTitle: 'Event komunitas',
    eventUpdated: 'Event komunitas diperbarui',
    updateFailed: 'Gagal memperbarui event komunitas',
    eventNotFound: 'Event komunitas tidak ditemukan',
    backToSchedule: 'Kembali ke jadwal komunitas',
    editEvent: 'Edit event komunitas',
    editSubtitle: 'Perbarui detail side event Anda.',
    clickToChangeCover: 'Klik untuk mengganti sampul',
    locationLabel: 'Lokasi',
    venueAddress: 'Alamat tempat',
    options: 'Opsi',
    claimNftFailed: 'Gagal mengklaim NFT',
    signInToClaimNft: 'Masuk untuk mengklaim NFT Anda',
    signInToClaimNftDesc: 'Anda harus masuk untuk mengklaim NFT bukti kehadiran Anda.',
    nftClaimedDesc: 'NFT bukti kehadiran Anda tersimpan. Lihat di profil Anda di Tiket Saya.',
    viewInMyTickets: 'Lihat di tiket saya',
    couldNotClaimNft: 'Tidak dapat mengklaim NFT',
    claimingNft: 'Mengklaim NFT Anda...',
    viewSchedule: 'Lihat jadwal komunitas',

    titlePlaceholder: 'mis. Makan malam di tempat lokal',
    descriptionPlaceholder: 'Jelaskan acara Anda — apa yang akan terjadi, siapa yang harus datang?',
    venueLabelPlaceholder: 'mis. Lobi Pusat Konvensi',
    venueDetailPlaceholder: 'mis. Lobi utama, Meja 5',
    addressPlaceholder: 'mis. Jl. Utama 123, Ruang 204',
    unlimitedCapacityPlaceholder: 'Tidak terbatas',
  },

  // ─── Sesi ─────────────────────────────────────────────────────
  sessions: {
    title: 'Sesi',
    addSession: 'Tambah Sesi',
    speaker: 'Pembicara',
    speakers: 'Pembicara',
    duration: '{{duration}} menit',
    room: 'Ruangan',
    workshop: 'Workshop',
    talk: 'Presentasi',
    panel: 'Panel',
    break: 'Istirahat',
    rsvpSession: 'Pesan Tempat',
    cancelRsvp: 'Batalkan Reservasi',
    spotsLeft: 'Tersisa {{count}} tempat',
    full: 'Penuh',
    titlePlaceholder: 'Judul sesi',
    customTypePlaceholder: 'mis. Pemutaran, Keynote, Diskusi',
    locationPlaceholder: 'mis. Panggung Utama, Hacker Den, Ruang B',
    speakerPlaceholder: 'Nama pembicara (opsional)',
    descriptionPlaceholder: 'Apa yang bisa diharapkan peserta (opsional)',
    capacityPlaceholder: 'Kosongkan untuk tidak terbatas (sesi terbuka)',
    selectOption: 'Pilih...',
  },

  // ─── Analitik ─────────────────────────────────────────────────
  analytics: {
    title: 'Analitik',
    pageViews: 'Kunjungan Halaman',
    totalRsvps: 'Total RSVP',
    confirmed: 'Terkonfirmasi',
    checkedIn: 'Sudah Check-in',
    checkInRate: 'Tingkat Check-in',
    waitlisted: 'Daftar Tunggu',
    cancelled: 'Dibatalkan',
    rsvpTrend: 'Tren RSVP',
    deviceBreakdown: 'Jenis Perangkat',
    mobile: 'Ponsel',
    desktop: 'Desktop',
    topLocations: 'Lokasi Teratas',
    exportData: 'Ekspor Data',
  },

  // ─── Buat Event (tambahan) ─────────────────────────────────────
  events: {
    createEvent: 'Buat Event',
    createEventDesc: 'Buat event baru di Creatix. Atur detail event, tiket, dan pendaftaran.',
    createEventSubtitle: 'Buat event gratis dan mulai bangun komunitas Anda',
    generalAdmission: 'Masuk Umum',
    draftRestored: 'Draf dipulihkan',
    draftRestoredDesc: 'Progres sebelumnya telah dimuat',
    ticketArtRequired: 'Semua jenis tiket harus memiliki gambar tiket',
    regQuestionsNotSaved: 'Pertanyaan pendaftaran tidak dapat disimpan. Anda dapat mengaturnya nanti di Kelola Event.',
    restoreDraft: 'Pulihkan draf sebelumnya?',
    restoreDraftDesc: 'Kami menemukan progres tersimpan dari sesi terakhir Anda.',
    autoSaving: 'Menyimpan draf...',
    step: 'Langkah {{current}} dari {{total}}',
    creating: 'Membuat...',
    eventNotFound: 'Event tidak ditemukan',
    backToProfile: 'Kembali ke Profil',
  },

  // ─── Kelola Event ─────────────────────────────────────────────
  manageEvent: {
    title: 'Kelola Event',
    overview: 'Ikhtisar',
    overviewShort: 'Beranda',
    checkIn: 'Check-in',
    checkInShort: 'Cek',
    attendees: 'Peserta',
    registration: 'Pendaftaran',
    registrationShort: 'Daftar',
    insights: 'Wawasan',
    programme: 'Program',
    programmeShort: 'Prog',
    collaborators: 'Kolaborator',
    collaboratorsShort: 'Kolab',
    invitations: 'Undangan',
    invitationsShort: 'Undang',
    promoImages: 'Gambar Promo',
    promoImagesShort: 'Gambar',
    settings: 'Pengaturan',
    settingsShort: 'Atur',
    checkInUnavailable: 'Check-in untuk sementara tidak tersedia',
    loadingProgramme: 'Memuat program...',

    // ─── SettingsForm ─────────────────────────────────────────
    settingsUpdated: 'Pengaturan event berhasil diperbarui!',
    updateFailed: 'Pembaruan Gagal',
    registrationQuestionnaire: 'Kuesioner pendaftaran',
    regQuestionnaireDesc: 'Atur apa yang dijawab tamu saat mereka RSVP. Klik Simpan perubahan jika sudah selesai.',
    ticketArtRequired: 'Harap unggah gambar tiket untuk semua jenis tiket sebelum menyimpan',
    cannotChangeFormat: 'Tidak Dapat Mengubah Format',
    formatChangeWarning: 'Perubahan ini akan memengaruhi peserta yang sudah ada',
    saveChanges: 'Simpan perubahan',
    saving: 'Menyimpan...',
    savingChanges: 'Menyimpan perubahan...',
    changeFormat: 'Ubah Format Event?',
    keepCurrentFormat: 'Pertahankan Format Saat Ini',
    yesChangeFormat: 'Ya, Ubah Format',
    changingFormat: 'Mengubah format...',
    eventCancelled: 'Event berhasil dibatalkan',
    cancellationFailed: 'Pembatalan Gagal',
    eventSettings: 'Pengaturan event',
    eventSettingsDesc: 'Perbarui event Anda seperti saat membuatnya — detail, tiket, persetujuan, dan pertanyaan pendaftaran.',
    fixErrorsBeforeSaving: 'Harap perbaiki berikut sebelum menyimpan:',
    couldNotSave: 'Tidak dapat menyimpan',
    questionnaireNotSaved: 'Pengaturan lain berhasil disimpan, tetapi kuesioner pendaftaran tidak tersimpan.',
    eventSaved: 'Event tersimpan',
    formatWillCancel: 'Berpindah dari {{oldType}} ke {{newType}} akan membatalkan {{count}} peserta yang terkena dampak ({{affectedType}}). Mereka akan diberi tahu.',

    // ─── EventDangerZone ──────────────────────────────────────
    dangerZone: 'Zona Berbahaya',
    cancelEvent: 'Batalkan Event',
    cancelEventDesc: 'Ini akan membatalkan event dan mencegah pendaftaran atau check-in lebih lanjut. Tindakan ini tidak dapat dibatalkan.',
    cannotCancelToday: 'Event yang dimulai hari ini tidak dapat dibatalkan',
    areYouSure: 'Apakah Anda yakin?',
    cancelWarning: 'Tindakan ini akan menandai event sebagai <strong>Dibatalkan</strong>.',
    ticketSalesStopped: 'Penjualan tiket dan RSVP akan segera dihentikan.',
    eventPageBadge: 'Halaman event akan menampilkan lencana "Dibatalkan".',
    keepEvent: 'Pertahankan Event',
    cancelling: 'Membatalkan...',
    yesCancelEvent: 'Ya, Batalkan Event',
    deleteEvent: 'Hapus Event Permanen',
    deleteEventDesc: 'Ini akan menghapus permanen event draf ini dan semua data terkait. Tindakan ini tidak dapat dibatalkan.',
    deleteWarning: 'Berikut akan dihapus:',
    deletePermanent: 'Ya, Hapus Permanen',
    cannotUndo: 'Tindakan ini tidak dapat dibatalkan.',
    deleting: 'Menghapus...',
    yesDelete: 'Ya, Hapus Permanen',
    deleteConfirmTitle: 'Hapus event ini secara permanen?',
    deleteConfirmDesc: 'Ini akan menghapus permanen event <strong>{{title}}</strong> dan semua datanya.',
    deletedTypes: {
      ticketTiers: 'Jenis tiket dan semua tiket terjual',
      rsvpRecords: 'Catatan RSVP dan check-in',
      promoImages: 'Gambar promosi',
      programmeSessions: 'Sesi program / jadwal',
      collaboratorAssignments: 'Penugasan kolaborator dan undangan',
      registrationResponses: 'Respons kuesioner pendaftaran',
    },

    // ─── PromotionalImageManager ──────────────────────────────
    imagesUploaded: '{{count}}/{{max}} gambar diunggah',
    upload: 'Unggah',
    uploading: 'Mengunggah...',
    noPromoImages: 'Belum ada gambar promosi',
    uploadToShowcase: 'Unggah gambar untuk menampilkan event Anda',
    deletePromoImage: 'Hapus Gambar Promosi',
    deletePromoImageDesc: 'Yakin ingin menghapus gambar ini? Tindakan ini tidak dapat dibatalkan.',
    moveEarlier: 'Pindah ke atas',
    moveLater: 'Pindah ke bawah',
    deleteImage: 'Hapus gambar',
    viewRegistrationResponses: 'Lihat respons pendaftaran',

    // ─── AddQuestionModal ─────────────────────────────────────
    questionTypeText: 'Teks',
    questionTypeOptions: 'Pilihan',
    questionTypeSocial: 'Profil Sosial',
    questionTypeCompany: 'Perusahaan',
    questionTypeCheckbox: 'Kotak Centang',
    questionTypeTerms: 'Ketentuan',
    questionTypePhone: 'Telepon',
    questionTypeWebsite: 'Situs Web',
    editQuestion: 'Edit Pertanyaan',
    addQuestion: 'Tambah Pertanyaan',
    addQuestionDesc: 'Ajukan pertanyaan kustom kepada tamu saat mereka mendaftar.',
    backToTypes: '← Kembali ke jenis pertanyaan',
    questionLabel: 'Label pertanyaan',
    questionLabelPlaceholder: 'Mis. Kebutuhan diet',
    placeholderOptional: 'Placeholder (opsional)',
    placeholderExample: 'Mis. Vegetarian, alergi...',
    allowMultiline: 'Izinkan multiline (paragraf)',
    optionsOnePerLine: 'Pilihan (satu per baris)',
    optionN: 'Pilihan {{n}}',
    addOption: '+ Tambah pilihan',
    termsText: 'Teks ketentuan',
    termsPlaceholder: 'Saya setuju dengan syarat dan ketentuan...',
    required: 'Wajib',

    // ─── AttendeeResponsesModal ───────────────────────────────
    registrationResponses: 'Respons Pendaftaran',
    name: 'Nama',
    email: 'Email',
    phone: 'Telepon',
    solanaWallet: 'Dompet Solana',
    noResponses: 'Tidak ada respons tambahan yang tercatat.',

    // ─── RegistrationSettings ─────────────────────────────────
    registrationQuestions: 'Pertanyaan Pendaftaran',
    regQuestionsDesc: 'Kami akan menanyakan pertanyaan berikut kepada tamu saat mereka mendaftar untuk event.',
    personalInfo: 'Informasi Pribadi',
    nameFormat: 'Format nama',
    nameFormatDesc: 'Bagaimana nama tamu dikumpulkan saat pendaftaran',
    fullName: 'Nama lengkap',
    firstLastName: 'Nama depan dan belakang',
    emailLabel: 'Email',
    fromProfile: 'Dari profil',
    web3Identity: 'Identitas Web3',
    solanaAddress: 'Alamat Solana',
    collectWalletDesc: 'Kumpulkan alamat dompet',
    customQuestions: 'Pertanyaan Kustom',
    noCustomQuestions: 'Tidak ada pertanyaan kustom. Klik "Tambah Pertanyaan" untuk menambahkan.',

    // ─── EnableAnalyticsCard ──────────────────────────────────
    enableAnalytics: 'Aktifkan Analitik',
    enableAnalyticsDesc: 'Lacak kunjungan halaman, pendaftaran, check-in, dan wawasan audiens mulai saat ini. Setelah diaktifkan, analitik tidak dapat dimatikan.',
    enabling: 'Mengaktifkan…',
    enableAnalyticsButton: 'Aktifkan Analitik',
    enableAnalyticsFailed: 'Gagal mengaktifkan analitik. Silakan coba lagi.',

    // ─── OverviewTab ──────────────────────────────────────────
    viewPublicPage: 'Lihat Halaman Publik',
    rsvps: 'RSVP',
    inPerson: 'Langsung',
    online: 'Online',
    ticketsSold: 'Tiket Terjual',
    eventDate: 'Tanggal Event',
    quickActions: 'Tindakan Cepat',
    editSettings: 'Edit Pengaturan',
    viewAttendees: 'Lihat Peserta',

    // ─── AttendeesTab ─────────────────────────────────────────
    attendeeManagement: 'Manajemen Peserta',
    searchAttendees: 'Cari peserta berdasarkan nama atau email...',
    typeToSearch: 'Ketik minimal 3 karakter untuk mencari',
    exporting: 'Mengekspor…',
    exportCsv: 'Ekspor CSV',
    allAttendees: 'Semua Peserta',
    inPersonOnly: 'Langsung Saja',
    onlineOnly: 'Online Saja',
    pending: 'Menunggu',
    confirmed: 'Terkonfirmasi',
    checkedIn: 'Sudah Check-in',
    waitlist: 'Daftar Tunggu',
    noPending: 'Tidak ada permintaan persetujuan yang menunggu',
    noConfirmed: 'Belum ada peserta terkonfirmasi',
    noCheckedIn: 'Belum ada yang check-in',
    waitlistEmpty: 'Daftar tunggu kosong',
    approve: 'Setujui',
    reject: 'Tolak',
    onWaitlist: 'Dalam Antrean',
    checked: 'Sudah',
    toOnline: 'Ke Online',
    toInPerson: 'Ke Langsung',
    remove: 'Hapus',
    responses: 'Respons',
    loadMore: 'Muat lebih banyak peserta',
    switchType: 'Ganti Tipe Kehadiran',
    switchDesc: 'Ganti <strong>{{name}}</strong> ke <strong>{{type}}</strong>? ',
    switchDescOnline: ' Mereka akan kehilangan akses check-in langsung dan menerima tautan kehadiran online sebagai gantinya.',
    switchDescInPerson: ' Mereka akan kehilangan akses online dan perlu check-in di tempat sebagai gantinya.',
    removeAttendee: 'Hapus Peserta',
    removeAttendeeDesc: 'Yakin ingin menghapus <strong>{{name}}</strong> dari event ini? Ini akan membatalkan RSVP mereka dan membebaskan tempat untuk peserta daftar tunggu.',

    // ─── CheckInTab ───────────────────────────────────────────
    eventCheckIn: 'Check-in Event',
    eventCheckInDescDefault: 'Scan kode QR tiket peserta secara manual atau cari peserta di bawah.',
    eventCheckInDescOnlineHybrid: 'Gunakan kode dinamis untuk check-in mandiri, atau cari peserta di bawah untuk check-in mereka secara manual.',
    failedToLoadStats: 'Gagal memuat statistik peserta',
    totalCheckedIn: 'Total Check-in',
    physical: 'Fisik',
    virtual: 'Virtual',
    showCheckInCode: 'Tampilkan Kode Check-In',
    close: 'Tutup',
    openManualScanner: 'Buka Pemindai Manual',
    orSearchAttendees: 'Atau cari peserta',
    recentCheckIns: 'Check-in Terbaru',
    noCheckedInYet: 'Belum ada peserta yang check-in',
    getCheckInQrBanner: 'Dapatkan QR Check-in untuk Banner',
    bannerCheckInQr: 'QR check-in banner',
    bannerCheckInQrDesc: 'Peserta scan ini untuk check-in di tempat dan membuka event komunitas.',
    failedToLoadQr: 'Gagal memuat QR',

    // ─── CollaboratorsTab ─────────────────────────────────────
    collaboratorsSectionTitle: 'Kolaborator Event',
    collaboratorsDesc: 'Kolaborator memiliki izin untuk mengelola peserta, check-in tamu, dan mengedit detail event.',
    addNewCollaborator: 'Tambah Kolaborator Baru',
    addNewCollabDesc: 'Berikan akses manajemen kepada pengguna lain melalui email atau username.',
    searchByUsername: 'Cari berdasarkan username atau nama',
    orEnterUsername: 'Masukkan username atau email',
    enterManually: 'Tidak menemukan? Masukkan username atau email',
    selectedCollaborator: 'Kolaborator terpilih',
    clearSelection: 'Hapus pilihan',
    alreadyCollaborator: 'Pengguna ini sudah menjadi kolaborator',
    selectRole: 'Pilih peran',
    admin: 'Admin',
    noCollaborators: 'Belum ada kolaborator',
    removeCollaboratorConfirm: 'Yakin ingin menghapus kolaborator ini?',

    // ─── InvitationsTab ───────────────────────────────────────
    eventInvitations: 'Undangan Event',
    invitationsDesc: 'Undang orang ke event Anda melalui email. Tamu yang diundang akan menerima notifikasi dan dapat RSVP langsung.',
    inviteByUsername: 'Undang berdasarkan Username',
    inviteByUsernameDesc: 'Cari pengguna terdaftar berdasarkan username atau email.',
    sendInvitation: 'Kirim Undangan',
    sendInvitationDesc: 'Masukkan alamat email untuk mengirim undangan event.',
    enterEmail: 'Masukkan alamat email',
    sendInvite: 'Kirim Undangan',
    noInvitations: 'Belum ada undangan terkirim',
    inviteByEmail: 'Undang seseorang melalui email menggunakan formulir di atas',
    cancelInvitationConfirm: 'Yakin ingin membatalkan undangan ini?',
    collaboratorAdded: 'Kolaborator ditambahkan',
    collaboratorRemoved: 'Kolaborator dihapus',
    failedToAddCollaborator: 'Gagal menambahkan kolaborator',
    failedToRemoveCollaborator: 'Gagal menghapus kolaborator',
    invitationSent: 'Undangan terkirim',
    failedToSendInvitation: 'Gagal mengirim undangan',
    invitationAccepted: 'Undangan diterima',
    failedToAcceptInvitation: 'Gagal menerima undangan',
    invitationDeclined: 'Undangan ditolak',
    failedToDeclineInvitation: 'Gagal menolak undangan',
    invitationCancelled: 'Undangan dibatalkan',
    failedToCancelInvitation: 'Gagal membatalkan undangan',
    imageUploaded: 'Gambar diunggah',
    failedToUploadImage: 'Gagal mengunggah gambar',
    imageDeleted: 'Gambar dihapus',
    failedToDeleteImage: 'Gagal menghapus gambar',
    imagesReordered: 'Gambar diurutkan ulang',
    failedToReorderImages: 'Gagal mengurutkan ulang gambar',
    exportFailed: 'Ekspor gagal',

    // ─── ProgrammeTab ─────────────────────────────────────────
    sessionDeleted: 'Sesi dihapus',
    sessionPublished: 'Sesi dipublikasikan',
    sessionUnpublished: 'Sesi tidak dipublikasikan',
    deleteSessionConfirm: 'Yakin ingin menghapus sesi ini?',
    eventProgramme: 'Program Event',
    programmeDesc: 'Kelola jadwal dan sesi untuk event Anda.',
    allDays: 'Semua Hari',
    all: 'Semua',
    sessionsCount: '{{count}} sesi',
    sessionsCount_plural: '{{count}} sesi',
    sessionsCountDay: ' pada hari ini',
    addSession: 'Tambah Sesi',
    noSessions: 'Belum ada sesi',
    noSessionsDesc: 'Mulai bangun program event Anda.',
    addFirstSession: 'Tambah Sesi Pertama',
    noSessionsDate: 'Tidak ada sesi pada tanggal ini',
    noSessionsDateDesc: 'Ganti ke hari lain atau tambah sesi baru.',

    // ─── EventAnalytics ───────────────────────────────────────
    failedToLoadAnalytics: 'Gagal memuat analitik',
    noActivity: 'Belum ada aktivitas',
    noActivityDesc: 'Analitik akan muncul setelah peserta mulai mendaftar dan check-in ke event Anda.',
    from: 'Dari',
    to: 'Ke',
    granularity: 'Granularitas',
    hour: 'Jam',
    day: 'Hari',
    week: 'Minggu',
    performanceSummary: 'Ringkasan Kinerja',
    registrations: 'Pendaftaran',
    checkIns: 'Check-in',
    nftClaimed: 'NFT Diklaim',
    attendance: 'Kehadiran',
    noShow: 'Tidak Hadir',
    peakArrival: 'Puncak Kedatangan',
    pageViews: 'Kunjungan Halaman',
    totalRevenue: 'Total Pendapatan',
    registrationClaimBehavior: 'Perilaku Pendaftaran & Klaim',
    claimToCheckIn: 'Klaim-ke-Check-in',
    last24hSurge: 'Lonjakan 24 Jam Terakhir',
    registrationsBeforeEvent: 'pendaftaran sebelum event',
    capacity: 'Kapasitas',
    unlimited: 'Tak Terbatas',
    registrationTrend: 'Tren Pendaftaran',
    pageViewsOverTime: 'Kunjungan Halaman dari Waktu ke Waktu',
    attendanceType: 'Tipe Kehadiran',
    analyticsWaitlist: 'Daftar Tunggu',
    analyticsOnWaitlist: 'Dalam Antrean',
    analyticsConfirmed: 'Terkonfirmasi',
    conversionRate: 'Tingkat Konversi',
    sessions: 'Sesi',
    session: 'Sesi',
    analyticsRsvps: 'RSVP',
    audienceDistribution: 'Distribusi Audiens',
    audienceEmpty: 'Wawasan audiens detail akan muncul untuk pendaftaran baru.',
    deviceType: 'Tipe Perangkat',
    topCities: 'Kota Teratas',
    browser: 'Peramban',
    ticketTiers: 'Jenis Tiket',
    registrationStatus: 'Status Pendaftaran',
    eventTimeline: 'Linimasa Event',
    registrationGrowth: 'Pertumbuhan Pendaftaran',
    checkInFlow: 'Alur Check-in',
    chartCumulative: 'Kumulatif',
    chartDaily: 'Harian',
    chartViews: 'Kunjungan',
    chartSold: 'Terjual',
    chartTotal: 'Total',
    peakPrefix: 'Puncak:',
    analyticsCancelled: 'Dibatalkan',
  },

  // ─── Groups ───────────────────────────────────────────────────
  groups: {
    myGroups: 'Grup Saya',
    createTitle: 'Buat Grup',
    createButton: 'Buat Grup',
    name: 'Nama grup',
    namePlaceholder: 'mis. Superteam Hub',
    description: 'Deskripsi',
    website: 'Situs web',
    websitePlaceholder: 'https://',
    industry: 'Industri',
    logo: 'Logo',
    banner: 'Banner',
    settings: 'Pengaturan',
    settingsTitle: 'Pengaturan Grup',
    memberCount: '{{count}} anggota',
    upcomingEvents: 'Acara Mendatang',
    pastEvents: 'Acara Lalu',
    noUpcomingEvents: 'Belum ada acara mendatang.',
    notFound: 'Grup tidak ditemukan',
    empty: 'Anda belum menjadi anggota grup mana pun.',
    emptyTitle: 'Belum ada grup',
    notFoundTitle: 'Grup tidak ditemukan',
    loadFailed: 'Gagal memuat grup',
    created: 'Grup dibuat',
    createFailed: 'Gagal membuat grup',
    updated: 'Grup diperbarui',
    updateFailed: 'Gagal memperbarui grup',
    deleted: 'Grup dihapus',
    deleteFailed: 'Gagal menghapus grup',
    deleteGroup: 'Hapus grup',
    deleteConfirmTitle: 'Hapus grup ini?',
    deleteConfirmDesc: 'Acara yang terhubung akan diputus dari grup tetapi tidak dihapus.',
    memberAdded: 'Anggota ditambahkan',
    memberAddFailed: 'Gagal menambahkan anggota',
    memberRemoved: 'Anggota dihapus',
    memberRemoveFailed: 'Gagal menghapus anggota',
    removeMemberConfirmTitle: 'Hapus anggota ini?',
    removeMemberConfirmDesc: 'Hapus {{name}} dari grup? Mereka akan kehilangan akses ke pengaturan grup.',
    addMember: 'Tambah anggota',
    inviteRole: 'Peran',
    transferOwnership: 'Transfer kepemilikan',
    transferOwnershipConfirm: 'Jadikan anggota ini pemilik grup? Anda akan menjadi admin.',
    ownershipTransferred: 'Kepemilikan ditransfer',
    ownershipTransferFailed: 'Gagal mentransfer kepemilikan',
    membersReadOnly: 'Hanya pemilik dan admin yang dapat mengelola pengaturan grup.',
    linkEvent: 'Hubungkan acara',
    linkEventToGroupDesc: 'Hubungkan salah satu acara Anda ke grup ini.',
    noEventsToLink: 'Tidak ada acara yang belum terhubung.',
    memberUserIdPlaceholder: 'ID pengguna (UUID)',
    linkOnCreate: 'Hubungkan ke grup (opsional)',
    noGroup: 'Tanpa grup',
    eventLinkTitle: 'Grup',
    linkEventDesc: 'Hubungkan acara ini ke salah satu grup Anda.',
    unlinkEvent: 'Putus dari grup',
    noGroupsToLink: 'Bergabung atau buat grup terlebih dahulu.',
    noLinkedEvents: 'Tidak ada acara yang terhubung ke grup ini.',
    tabs: {
      details: 'Detail',
      members: 'Anggota',
      events: 'Acara',
    },
    roles: {
      owner: 'Pemilik',
      admin: 'Admin',
      member: 'Anggota',
    },
    validation: {
      nameMin: 'Nama grup minimal 2 karakter',
      nameMax: 'Nama grup maksimal 100 karakter',
      descriptionMax: 'Deskripsi maksimal 2000 karakter',
      invalidUrl: 'URL tidak valid',
    },
  },

  // ─── Login Dev/Test ───────────────────────────────────────────
  dev: {
    title: 'Login Dev/Test',
    username: 'Username',
    usernamePlaceholder: 'Masukkan username',
    password: 'Kata Sandi',
    passwordPlaceholder: 'Kata sandi dev',
    loggingIn: 'Masuk...',
    login: 'Masuk (Khusus Dev)',
    loginFailed: 'Login gagal',
    loginError: 'Gagal login',
  },

  // ─── Dompet ───────────────────────────────────────────────────
  wallet: {
    connected: 'Dompet terhubung!',
    readyToAttend: 'Anda siap menghadiri acara',
    connect: 'Hubungkan Dompet',
    connectedWallet: 'Dompet Terhubung',
    balance: 'Saldo',
    balanceSol: '{{balance}} SOL',
    disconnect: 'Putuskan',
  },

  // ─── Umum ─────────────────────────────────────────────────────
  common: {
    save: 'Simpan',
    cancel: 'Batalkan',
    delete: 'Hapus',
    confirm: 'Konfirmasi',
    back: 'Kembali',
    next: 'Lanjut',
    previous: 'Sebelumnya',
    restore: 'Pulihkan',
    discard: 'Buang',
    tryAgain: 'Coba Lagi',
    continue: 'Lanjutkan',
    submit: 'Kirim',
    close: 'Tutup',
    edit: 'Edit',
    update: 'Perbarui',
    remove: 'Hapus',
    add: 'Tambah',
    create: 'Buat',
    publish: 'Publikasikan',
    share: 'Bagikan',
    copy: 'Salin',
    copied: 'Tersalin!',
    loading: 'Memuat...',
    saving: 'Menyimpan...',
    submitting: 'Mengirim...',
    search: 'Cari',
    filter: 'Filter',
    clearFilters: 'Hapus Filter',
    viewAll: 'Lihat semua',
    seeMore: 'Lihat lebih banyak',
    seeLess: 'Lebih sedikit',
    optional: 'Opsional',
    required: 'Wajib',
    or: 'atau',
    and: 'dan',
    yes: 'Ya',
    no: 'Tidak',
    notAvailable: 'N/A',
    comingSoon: 'Segera Hadir',
    new: 'Baru',
    free: 'Gratis',
    guest: 'Tamu',
    there: 'teman',
    someone: 'Seseorang',
    today: 'Hari Ini',
    yesterday: 'Kemarin',
    tomorrow: 'Besok',
    dateAt: '{{date}} pukul {{time}}',
    keep: 'Pertahankan',
    retry: 'Coba Lagi',
    switch: 'Ganti',
    devnet: 'Devnet',
    connectedTo: 'Terhubung ke {{network}}',
    notSet: 'Belum diatur',
    enabled: 'Diaktifkan',
    disabled: 'Dinonaktifkan',
    download: 'Unduh',
    linkCopied: 'Tautan disalin ke clipboard!',
  },

  // ─── Validasi ─────────────────────────────────────────────────
  validation: {
    required: 'Kolom ini wajib diisi',
    titleMin: 'Judul minimal 5 karakter',
    titleMax: 'Judul maksimal 50 karakter',
    summaryMin: 'Ringkasan minimal 10 karakter',
    summaryMax: 'Ringkasan maksimal 200 karakter',
    invalidEmail: 'Alamat email tidak valid',
    invalidUrl: 'URL tidak valid',
    capacityMin: 'Kapasitas minimal 1',
    deadlineFuture: 'Tenggat waktu harus di masa depan',
    goalMin: 'Target harus lebih dari 0',
    categoriesMin: 'Pilih minimal 1 kategori',
    categoriesMax: 'Pilih maksimal 3 kategori',
    categoriesRequired: 'Pilih minimal 1 kategori',
    descriptionMin: 'Deskripsi minimal 50 karakter',
    cityCountryRequired: 'Kota dan Negara wajib diisi untuk event tatap muka/hibrida',
    onlineLinkRequired: 'Tautan online wajib diisi untuk event online',
    onlineLinkInvalid: 'Tautan online harus URL valid dengan http:// atau https://',
    startDateFuture: 'Tanggal mulai harus di masa depan',
    endDateAfterStart: 'Tanggal selesai harus setelah tanggal mulai',
    priceNonNegative: 'Harga tidak boleh negatif',
    integer: 'Nilai harus berupa bilangan bulat',
    attendanceTypeMin: 'Pilih minimal satu tipe kehadiran',
    checkinCodeLength: 'Kode check-in harus 8 karakter',
    checkinCodeHex: 'Kode check-in harus heksadesimal',
    provideIdentifier: 'Berikan ticketId, rsvpId, atau userId',
    usernameRegex: 'Username hanya boleh berisi huruf, angka, tanda hubung, dan garis bawah',
    empty: 'Kolom ini tidak boleh kosong',
    userIdOrEmail: 'Berikan userId atau email',
    optionsMin: 'Pilihan ganda harus memiliki minimal 2 opsi',
    imageType: 'File harus berupa gambar JPEG, PNG, WebP, atau GIF',
    fileSizeMax: 'Ukuran file maksimal 10 MB',
    imageMaxCount: 'Maksimal 10 gambar promosi per event',
    invalidPhone: 'Format telepon tidak valid',
    invalidWallet: 'Dompet Solana tidak valid',
  },

  // ─── Error ────────────────────────────────────────────────────
  errors: {
    generic: 'Terjadi kesalahan. Silakan coba lagi.',
    notFound: 'Tidak ditemukan',
    unauthorized: 'Anda tidak memiliki izin untuk melakukan ini',
    networkError: 'Kesalahan jaringan. Periksa koneksi Anda.',
    eventNotFound: 'Event tidak ditemukan',
    ticketNotFound: 'Tiket tidak ditemukan',
    sessionExpired: 'Sesi Anda telah berakhir. Silakan masuk kembali.',
    capacityFull: 'Event ini sudah penuh',
    alreadyRsvp: 'Anda sudah mendaftar untuk event ini',
    appError: 'Kesalahan Aplikasi',
    appErrorDescription: 'Terjadi kesalahan di sisi klien. Silakan coba muat ulang halaman.',
    stackTrace: 'Jejak tumpukan',
    refreshPage: 'Muat Ulang Halaman',
    tryAgain: 'Coba Lagi',
    locationLookupFailed: 'Pencarian lokasi gagal',
    pageNotFound: 'Halaman Tidak Ditemukan',
    pageNotFoundDesc: 'Maaf, kami tidak dapat menemukan halaman yang Anda cari.',
    unauthorizedDesc: 'Anda tidak memiliki izin untuk mengakses halaman ini.',
    serviceUnavailable: 'Layanan Tidak Tersedia',
    serviceUnavailableDesc: 'Server kami sedang mengalami masalah. Silakan coba lagi nanti.',
    genericTitle: 'Ups! Terjadi kesalahan',
    updateAvailable: 'Pembaruan Tersedia',
    hardRefreshRequired: 'Kami baru merilis versi baru Creatix! Lakukan hard refresh (Ctrl+F5 atau Cmd+Shift+R) untuk memuatnya.',
    unknown: 'Kesalahan Tidak Dikenal',
    unknownDesc: 'Terjadi kesalahan yang tidak diketahui.',
    errorCode: 'Kode Kesalahan: {{status}}',
    loadTicketFailed: 'Gagal memuat tiket',
    uploadImageFailed: 'Gagal mengunggah gambar',
    updateFailed: 'Pembaruan gagal',
    exportScheduleFailed: 'Gagal mengekspor jadwal',
  },

  // ─── Footer ───────────────────────────────────────────────────
  footer: {
    xAria: 'X (Twitter)',
    instagramAria: 'Instagram',
    emailAria: 'Email',
    brand: 'Creatix',
    tagline: 'Platform Event',
    upcomingEventCount_one: '{{count}} event mendatang',
    upcomingEventCount_other: '{{count}} event mendatang',
    privacyAria: 'Kebijakan Privasi',
    termsAria: 'Syarat Layanan',
  },

  // ─── Legal ────────────────────────────────────────────────────
  legal: {
    privacyTitle: 'Kebijakan Privasi',
    privacyDescription: 'Pelajari bagaimana Creatix mengumpulkan, menggunakan, dan melindungi informasi pribadi Anda.',
    termsTitle: 'Syarat Layanan',
    termsDescription: 'Baca Syarat Layanan untuk menggunakan Creatix. Pelajari kebijakan, perjanjian pengguna, dan aturan platform kami.',
    lastUpdated: 'Terakhir diperbarui: {{date}}',
    unsubscribed: 'Anda berhenti berlangganan',
    unsubscribedDesc: 'Anda tidak akan menerima email notifikasi event dari Creatix lagi. Anda masih dapat masuk dan ',
    manageNotificationPreferences: 'kelola preferensi notifikasi Anda',
    requiresLogin: '(memerlukan login).',
    invalidLink: 'Tautan tidak valid atau kedaluwarsa',
    missingToken: 'Token berhenti berlangganan tidak disediakan.',
    invalidOrUsed: 'Tautan berhenti berlangganan ini tidak valid atau sudah digunakan.',
    backToCreatix: 'Kembali ke Creatix',
    privacy: {
      section1Title: '1. Informasi yang Kami Kumpulkan',
      section1Intro: 'Kami mengumpulkan informasi yang Anda berikan langsung saat membuat akun, membuat atau menghadiri event, atau berkomunikasi dengan kami. Ini termasuk:',
      section1Item1: 'Informasi akun (username, email, alamat dompet)',
      section1Item2: 'Informasi profil (bio, avatar, tautan sosial)',
      section1Item3: 'Informasi event (saat Anda membuat event)',
      section1Item4: 'Data komunikasi (saat Anda menghubungi dukungan)',
      section2Title: '2. Bagaimana Kami Menggunakan Informasi Anda',
      section2Intro: 'Kami menggunakan informasi yang kami kumpulkan untuk menyediakan, memelihara, dan meningkatkan layanan kami, termasuk untuk:',
      section2Item1: 'Memproses transaksi dan mengirim informasi terkait',
      section2Item2: 'Mengirim pemberitahuan teknis, pembaruan, dan pesan dukungan',
      section2Item3: 'Menanggapi komentar dan pertanyaan Anda',
      section2Item4: 'Memantau dan menganalisis tren dan penggunaan',
      section3Title: '3. Berbagi Data',
      section3Intro: 'Kami tidak menjual data pribadi Anda. Kami dapat membagikan informasi Anda dalam keadaan berikut:',
      section3Item1: 'Dengan persetujuan Anda',
      section3Item2: 'Untuk alasan hukum',
      section3Item3: 'Dengan penyedia layanan yang membantu kami mengoperasikan bisnis',
      section4Title: '4. Hubungi Kami',
      section4Body: 'Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, hubungi kami di creatixplatform@gmail.com.',
    },
    terms: {
      section1Title: '1. Penerimaan Syarat',
      section1Body: 'Dengan mengakses atau menggunakan situs web dan layanan kami, Anda setuju terikat oleh Syarat Layanan ini dan semua hukum serta peraturan yang berlaku.',
      section2Title: '2. Lisensi Penggunaan',
      section2Body: 'Izin diberikan untuk mengunduh sementara satu salinan materi (informasi atau perangkat lunak) di situs web Creatix hanya untuk melihat sementara non-komersial pribadi.',
      section3Title: '3. Pembuatan dan Kehadiran Event',
      section3Intro: 'Pengguna dapat membuat dan menghadiri event melalui platform kami. Dengan membuat event, Anda menyatakan bahwa:',
      section3Item1: 'Anda memiliki wewenang untuk menyelenggarakan event',
      section3Item2: 'Event tidak melanggar hukum atau peraturan',
      section3Item3: 'Konten event tidak menyinggung atau berbahaya',
      section4Title: '4. Transaksi Blockchain',
      section4Body: 'Platform kami menggunakan teknologi blockchain. Anda mengakui bahwa transaksi blockchain tidak dapat dibatalkan dan Anda sepenuhnya bertanggung jawab memastikan keakuratan detail transaksi Anda.',
      section5Title: '5. Batasan Tanggung Jawab',
      section5Body: 'Dalam keadaan apa pun Creatix atau pemasoknya tidak bertanggung jawab atas kerugian apa pun (termasuk, tanpa batasan, kerugian data atau keuntungan, atau karena gangguan bisnis) yang timbul dari penggunaan atau ketidakmampuan menggunakan materi di situs web Creatix.',
    },
  },

  // ─── Undangan ─────────────────────────────────────────────────
  invitation: {
    invalid: 'Undangan Tidak Valid',
    invalidDesc: 'Tautan undangan ini tidak valid atau telah kedaluwarsa.',
    accepted: 'Undangan Diterima!',
    acceptedDesc: 'Anda telah ditambahkan ke event. Periksa event Anda untuk melihat detail.',
    viewMyEvents: 'Lihat Event Saya',
    declined: 'Undangan Ditolak',
    declinedDesc: 'Anda telah menolak undangan event ini.',
    promptTitle: 'Anda Diundang!',
    promptDesc: 'Anda diundang ke sebuah event. Apakah Anda ingin menerima atau menolak undangan ini?',
    accept: 'Terima',
    decline: 'Tolak',
  },

  // ─── Jadwal (halaman program event) ───────────────────────────
  schedule: {
    myProgramme: 'Program Saya',
    listView: 'Tampilan Daftar',
    gridView: 'Tampilan Grid',
    allRooms: 'Semua Ruangan',
    allTypes: 'Semua Tipe',
    dayLabel: 'Hari {{n}}',
    happeningNow: 'Sedang Berlangsung',
    upNext: 'Selanjutnya',
    startingSoon: 'Segera Dimulai',
    scheduleConflict: 'Konflik jadwal: bertumpuk dengan {{count}} sesi lain di program Anda',
    scheduleConflict_other: 'Konflik jadwal: bertumpuk dengan {{count}} sesi lain di program Anda',
    concurrent: 'Bersamaan',
    rsvpToSeeLocation: 'RSVP untuk melihat lokasi',
    unassigned: 'Belum ditetapkan',
    today: 'Hari Ini',
    addProgrammeToCalendar: 'Tambah Program ke Kalender',
    addFullScheduleToCalendar: 'Tambah Jadwal Lengkap ke Kalender',
    subscribe: 'Berlangganan',
    appleOutlook: 'Apple / Outlook',
    autoUpdatesNative: 'Memperbarui kalender native secara otomatis',
    googleCalendar: 'Google Calendar',
    addViaBrowser: 'Tambah melalui browser web',
    download: 'Unduh',
    downloadIcs: 'Unduh File .ics',
    staticFileNoUpdates: 'File statis, tanpa pembaruan otomatis',
  },

  // ─── Partner Portal ───────────────────────────────────────────
  partner: {
    pages: {
      directory: 'Direktori Mitra',
      directoryDesc: 'Temukan mitra dan kolaborator Creatix.',
      register: 'Jadi Mitra',
      registerDesc: 'Bergabung dengan jaringan mitra Creatix.',
      detail: 'Profil Mitra',
      detailDesc: 'Lihat profil dan metrik mitra.',
      dashboard: 'Dasbor Mitra',
      dashboardDesc: 'Kelola profil mitra dan lacak progres Anda.',
    },
    fields: {
      type: 'Tipe mitra',
      organizationName: 'Nama organisasi',
      organizationNamePlaceholder: 'Organisasi atau merek Anda',
      description: 'Deskripsi',
      descriptionPlaceholder: 'Ceritakan tentang organisasi Anda',
      website: 'Situs web',
      capabilities: 'Kemampuan',
      social: {
        twitter: 'Twitter / X',
        instagram: 'Instagram',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
      },
    },
    types: {
      community: 'Komunitas',
      eo: 'Penyelenggara Acara',
      media: 'Media',
      production: 'Produksi',
      operations: 'Operasional',
      kol: 'KOL / Influencer',
      web3_project: 'Proyek Web3',
      vendor: 'Vendor',
    },
    tiers: {
      Bronze: 'Perunggu',
      Silver: 'Perak',
      Gold: 'Emas',
    },
    status: {
      Pending: 'Menunggu',
      Active: 'Aktif',
      Suspended: 'Ditangguhkan',
      Deactivated: 'Nonaktif',
    },
    capabilities: {
      co_hosting: 'Co-hosting',
      event_promotion: 'Promosi acara',
      media_coverage: 'Liputan media',
      content_creation: 'Pembuatan konten',
      av_production: 'Produksi AV',
      lighting: 'Pencahayaan',
      decor: 'Dekorasi',
      venue_provision: 'Penyediaan venue',
      catering: 'Katering',
      security: 'Keamanan',
      staffing: 'Staf',
      ticket_sales: 'Penjualan tiket',
      sponsorship: 'Sponsor',
      brand_activation: 'Aktivasi merek',
      web3_integration: 'Integrasi Web3',
      community_building: 'Pembangunan komunitas',
      influencer_promotion: 'Promosi influencer',
    },
    validation: {
      typeRequired: 'Tipe mitra wajib diisi',
      nameMinLength: 'Nama organisasi minimal 2 karakter',
      nameMaxLength: 'Nama organisasi maksimal 200 karakter',
      descriptionMaxLength: 'Deskripsi maksimal 1000 karakter',
      invalidUrl: 'URL tidak valid',
    },
    registration: {
      step: 'Langkah {{current}} dari {{total}}',
      selectType: 'Tipe mitra apa Anda?',
      organizationDetails: 'Detail organisasi',
      selectCapabilities: 'Pilih kemampuan Anda',
      capabilitiesHint: 'Pilih layanan yang dapat Anda berikan.',
      linksAndSocial: 'Tautan & sosial',
      review: 'Tinjau aplikasi Anda',
      back: 'Kembali',
      next: 'Lanjut',
      submit: 'Kirim aplikasi',
      successTitle: 'Aplikasi terkirim',
      successDesc: 'Kami akan meninjau aplikasi Anda dan menghubungi Anda segera.',
      duplicateName: 'Nama organisasi ini sudah terdaftar.',
      failed: 'Gagal mengirim aplikasi. Silakan coba lagi.',
      anonymousNote:
        'Jika Anda ingin mengelola profil mitra nanti, buat akun dan kami akan membantu menghubungkannya.',
    },
    directory: {
      back: 'Kembali ke direktori',
      searchPlaceholder: 'Cari mitra...',
      filterType: 'Tipe',
      filterTier: 'Tingkat',
      allTypes: 'Semua tipe',
      allTiers: 'Semua tingkat',
      apply: 'Terapkan',
      clear: 'Hapus',
      found: '{{count}} mitra ditemukan',
      empty: 'Tidak ada mitra ditemukan.',
      emptyTitle: 'Belum ada mitra',
      emptyDesc: 'Coba sesuaikan filter atau kembali lagi nanti.',
      loadFailed: 'Gagal memuat mitra.',
      retry: 'Coba lagi',
      loadMore: 'Muat lebih banyak',
      becomePartner: 'Jadi mitra',
      eventsCoHosted: '{{count}} acara co-hosted',
    },
    profile: {
      notFound: 'Mitra tidak ditemukan.',
      notFoundTitle: 'Mitra tidak ditemukan',
      loadFailed: 'Gagal memuat profil mitra.',
      loadFailedTitle: 'Tidak dapat memuat mitra',
      memberCount: '{{count}} anggota',
      metrics: 'Metrik kinerja',
    },
    metrics: {
      eventsCoHosted: 'Acara co-hosted',
      attendeesReferred: 'Peserta dirujuk',
      eventsPromoted: 'Acara dipromosikan',
      rating: 'Rating',
    },
    dashboard: {
      noPartner: 'Anda belum memiliki profil mitra.',
      registerCta: 'Daftar sebagai mitra',
      pendingTitle: 'Aplikasi sedang ditinjau',
      pendingDesc: 'Aplikasi mitra Anda sedang menunggu persetujuan. Kami akan memberi tahu setelah ditinjau.',
      noMetrics: 'Belum ada metrik tersedia.',
      comingSoon: 'Segera hadir.',
      tabs: {
        overview: 'Ringkasan',
        tier: 'Progres tingkat',
        settings: 'Pengaturan',
        coHosted: 'Acara co-hosted',
        referrals: 'Statistik rujukan',
      },
    },
    tierProgress: {
      title: 'Progres menuju {{tier}}',
      summary: '{{met}} dari {{total}} kriteria terpenuhi ({{required}} diperlukan)',
      maxTier: 'Anda telah mencapai tingkat maksimum.',
      eventsCoHosted: 'Acara co-hosted',
      attendeesReferred: 'Peserta dirujuk',
      monthsActive: 'Bulan aktif',
      rating: 'Rating',
      eventsPromoted: 'Acara dipromosikan',
      nextEvaluation: 'Evaluasi tingkat berikutnya: {{date}}',
    },
    settings: {
      logo: 'Logo',
      uploadLogo: 'Unggah logo',
      logoUpdated: 'Logo diperbarui',
      logoFailed: 'Gagal mengunggah logo',
      socialLinks: 'Tautan sosial',
      save: 'Simpan perubahan',
      saved: 'Profil diperbarui',
      saveFailed: 'Gagal menyimpan perubahan',
    },
  },

  // ─── PWA / Mobile ─────────────────────────────────────────────
  pwa: {
    offlineMessage: 'Anda offline. Terakhir diperbarui: {{time}}',
    backOnline: 'Kembali online',
    updateAvailable: 'Pembaruan tersedia — ketuk untuk memuat ulang',
    updateNow: 'Perbarui',
    installTitle: 'Instal Creatix',
    installPrompt: 'Instal Creatix untuk akses cepat',
    install: 'Instal',
    iosInstructions: 'Ketuk Bagikan, lalu Tambahkan ke Layar Utama',
    mobileNav: 'Navigasi mobile',
    queuedOffline: 'Disimpan offline — akan disinkronkan saat terhubung',
    qrOfflineWarning: 'Menggunakan QR tersimpan saat offline. Sambungkan untuk memperbarui.',
    qrExpiryWarning: 'QR mungkin kedaluwarsa. Sambungkan ke internet untuk memperbarui.',
    dismissBanner: 'Tutup',
    scannerTorch: 'Senter',
    scannerFullscreen: 'Layar penuh',
    scannerExitFullscreen: 'Keluar layar penuh',
  },

  report: {
    title: 'Laporkan konten',
    reportEvent: 'Laporkan event',
    description: 'Beritahu kami masalahnya. Tim kami akan meninjau laporan Anda.',
    reasonPlaceholder: 'Jelaskan masalahnya…',
    reasonRequired: 'Harap berikan alasan laporan.',
    submit: 'Kirim laporan',
    submitting: 'Mengirim…',
    submitFailed: 'Gagal mengirim laporan. Coba lagi.',
  },

  // ─── Admin Dashboard ──────────────────────────────────────────
  admin: {
    title: 'Dasbor Admin',
    accessDenied: 'Anda tidak memiliki akses admin',
    overview: 'Ringkasan',
    users: 'Pengguna',
    events: 'Event',
    partners: 'Mitra',
    reports: 'Laporan',
    auditLog: 'Log Audit',
    totalUsers: 'Total Pengguna',
    totalEvents: 'Total Event',
    publishedEvents: 'Event Terpublikasi',
    totalRsvps: 'Total RSVP',
    totalTickets: 'Total Tiket',
    totalCheckIns: 'Check-in',
    totalNfts: 'NFT Dicetak',
    activePartners: 'Mitra Aktif',
    searchUsers: 'Cari pengguna…',
    searchEvents: 'Cari event…',
    role: 'Peran',
    provider: 'Penyedia',
    status: 'Status',
    suspend: 'Tangguhkan',
    unsuspend: 'Batalkan Penangguhan',
    changeRole: 'Ubah Peran',
    changeState: 'Ubah Status',
    resolve: 'Selesaikan',
    dismiss: 'Abaikan',
    loading: 'Memuat…',
    noResults: 'Tidak ada hasil',
    auditNotAvailable: 'Log audit belum tersedia',
    audit: {
      unavailable: 'Log audit sementara tidak tersedia. Silakan coba lagi nanti.',
      action: 'Aksi',
      category: 'Kategori',
    },
    auditCategory: 'Kategori',
    auditAllCategories: 'Semua kategori',
    auditActionFilter: 'Filter menurut aksi…',
    reportReason: 'Alasan',
    reportDetail: 'Detail laporan',
    resolveNotePlaceholder: 'Catatan opsional untuk penyelesaian…',
    createdAt: 'Dibuat',
    organizer: 'Penyelenggara',
    eventState: 'Status',
    usersByProvider: 'Pengguna per provider',
    eventsByState: 'Acara per status',
    monthlyGrowth: 'Pertumbuhan bulanan (12 bulan)',
    month: 'Bulan',
    newUsers: 'Pengguna baru',
    newEvents: 'Acara baru',
    userDetail: 'Detail pengguna',
    eventDetail: 'Detail acara',
    noRole: 'Tanpa peran admin',
    suspendReason: 'Alasan',
    suspendReasonPlaceholder: 'Alasan penangguhan…',
    suspended: 'Ditangguhkan',
    active: 'Aktif',
    eventsCreated: 'Acara dibuat',
    rsvps: 'RSVP',
    joined: 'Bergabung',
    tickets: 'Tiket',
    checkIns: 'Check-in',
    sessions: 'Sesi',
    viewPublicPage: 'Lihat halaman publik',
    forceDelete: 'Hapus paksa',
    forceDeleteConfirm: 'Hapus acara ini secara permanen? Tindakan ini tidak dapat dibatalkan.',
    stateReasonPlaceholder: 'Alasan opsional untuk perubahan status…',
    cancelEventWarning: 'Membatalkan acara yang dipublikasikan akan memberi tahu semua peserta yang dikonfirmasi.',
    allRoles: 'Semua peran',
    allProviders: 'Semua provider',
    allStates: 'Semua status',
    actions: 'Tindakan',
    approve: 'Setujui',
    email: 'Email',
    linkedProviders: 'Provider terhubung',
    description: 'Deskripsi',
    eventDate: 'Tanggal acara',
    dateFrom: 'Dari tanggal',
    dateTo: 'Sampai tanggal',
    organizerIdFilter: 'ID pengguna penyelenggara…',
    categoryFilter: 'Kategori…',
    contact: 'Kontak',
    partnerType: 'Tipe',
    partnerTier: 'Tingkat',
    allStatuses: 'Semua status',
    suspendPartner: 'Tangguhkan',
    deactivate: 'Nonaktifkan',
    reactivate: 'Aktifkan kembali',
  },

  reviews: {
    sectionTitle: 'Ulasan',
    writeReview: 'Tulis Ulasan',
    writeReviewDesc: 'Bagikan pengalaman Anda dengan peserta lain.',
    yourRating: 'Rating Anda',
    reviewTextOptional: 'Ulasan (opsional)',
    postAnonymously: 'Posting secara anonim',
    submitReview: 'Kirim Ulasan',
    submitSuccess: 'Ulasan terkirim',
    submitError: 'Gagal mengirim ulasan',
    ratingRequired: 'Silakan pilih rating',
    ratingMin: 'Rating minimal 1',
    ratingMax: 'Rating maksimal 5',
    textMax: 'Ulasan maksimal 500 karakter',
    responseMax: 'Balasan maksimal 1000 karakter',
    rateStars: 'Beri {{count}} bintang',
    anonymousAttendee: 'Peserta Anonim',
    organizerResponse: 'Balasan penyelenggara',
    edit: 'Edit',
    delete: 'Hapus',
    respond: 'Balas',
    reviewCount: '{{count}} ulasan',
    noReviewsYet: 'Belum ada ulasan',
    emptyState: 'Jadilah yang pertama membagikan pengalaman.',
    sortNewest: 'Terbaru',
    sortHighest: 'Rating tertinggi',
    sortLowest: 'Rating terendah',
    loadMore: 'Muat lebih banyak',
    newOrganizer: 'Penyelenggara baru — belum ada rating',
    surveyTitle: 'Survei Pasca-Acara',
    surveyDesc: 'Bantu penyelenggara meningkatkan acara mendatang.',
    surveyLoading: 'Memuat survei…',
    surveyThankYou: 'Terima kasih!',
    surveyThankYouDesc: 'Feedback Anda telah terkirim.',
    surveySubmit: 'Kirim survei',
    surveySubmitSuccess: 'Survei terkirim',
    surveySubmitError: 'Gagal mengirim survei',
    surveyRequiredError: 'Harap jawab: {{question}}',
    surveyConfigTitle: 'Survei Pasca-Acara',
    surveyConfigDesc: 'Atur pertanyaan yang dijawab peserta setelah acara berakhir.',
    surveyConfigSaved: 'Konfigurasi survei disimpan',
    surveyConfigError: 'Gagal menyimpan konfigurasi survei',
    questionNumber: 'Pertanyaan {{number}}',
    questionPlaceholder: 'Masukkan pertanyaan',
    requiredQuestion: 'Wajib',
    options: 'Opsi',
    optionPlaceholder: 'Opsi {{number}}',
    addOption: 'Tambah opsi',
    addQuestion: 'Tambah pertanyaan',
    saveSurveyConfig: 'Simpan survei',
    questionRequired: 'Pertanyaan wajib diisi',
    questionMax: 'Pertanyaan maksimal 500 karakter',
    surveyMinQuestions: 'Minimal satu pertanyaan',
    surveyMaxQuestions: 'Maksimal 20 pertanyaan',
    questionType: {
      rating: 'Rating bintang',
      text: 'Jawaban teks',
      single_choice: 'Pilihan tunggal',
      multi_choice: 'Pilihan ganda',
    },
    rateSession: 'Beri rating',
    sessionRating: 'rata-rata {{rating}}',
  },

  streaming: {
    settingsTitle: 'Siaran langsung',
    settingsDesc: 'Atur cara peserta menonton siaran online Anda.',
    typeLabel: 'Jenis streaming',
    typeExternal: 'Tautan eksternal',
    typeEmbedded: 'Pemutar tersemat',
    typeZoom: 'Rapat Zoom',
    typeGoogleMeet: 'Google Meet',
    externalUrl: 'URL siaran',
    platform: 'Platform',
    videoId: 'ID video atau channel',
    recordingUrl: 'URL rekaman (opsional)',
    save: 'Simpan pengaturan streaming',
    saving: 'Menyimpan…',
    saveSuccess: 'Pengaturan streaming disimpan',
    saveError: 'Gagal menyimpan pengaturan streaming',
    joinStream: 'Gabung siaran',
    createZoom: 'Buat rapat Zoom',
    createGoogle: 'Buat Google Meet',
    zoomCreated: 'Rapat Zoom dibuat',
    googleCreated: 'Google Meet dibuat',
    meetingError: 'Gagal membuat rapat',
    integrationConnected: 'Akun Anda terhubung. Klik untuk membuat tautan rapat.',
    integrationRequired: 'Hubungkan akun Anda di pengaturan integrasi terlebih dahulu.',
    connected: 'Terhubung',
    notConnected: 'Belum terhubung',
    connect: 'Hubungkan',
    disconnect: 'Putuskan',
    zoomConnected: 'Akun Zoom terhubung',
    googleConnected: 'Akun Google terhubung',
    zoomConnectError: 'Gagal menghubungkan Zoom',
    googleConnectError: 'Gagal menghubungkan Google',
    integrationsTitle: 'Integrasi',
    integrationsDesc: 'Hubungkan Zoom atau Google untuk membuat tautan rapat otomatis.',
  },

  ticketTransfer: {
    title: 'Transfer Tiket',
    recipientLabel: 'Email atau alamat dompet penerima',
    recipientPlaceholder: 'email@example.com atau dompet Solana',
    messageLabel: 'Pesan (opsional)',
    messagePlaceholder: 'Tambahkan catatan pribadi untuk penerima…',
    nftWarning: 'Tiket ini memiliki NFT. NFT akan ditransfer ke penerima.',
    transferButton: 'Transfer Tiket',
    cancelButton: 'Batalkan Transfer',
    statusPending: 'Transfer tertunda ke {{email}} — kedaluwarsa {{date}}',
    statusTransferred: 'Ditransfer ke {{name}} pada {{date}}',
    statusReceived: 'Anda menerima tiket ini dari {{name}}',
    nftTransferPending: 'Transfer NFT tertunda…',
    claimTitle: 'Klaim Tiket Anda',
    claimButton: 'Klaim Tiket',
    claimSuccess: 'Tiket berhasil diklaim!',
    claimExpired: 'Tautan klaim ini telah kedaluwarsa.',
    claimAlreadyClaimed: 'Tiket ini sudah diklaim.',
    claimWrongAccount: 'Transfer ini dikirim ke akun yang berbeda.',
    signInPrompt: 'Masuk atau buat akun untuk mengklaim tiket Anda.',
    claimLoading: 'Memeriksa tiket Anda…',
    claimFailed: 'Gagal mengklaim tiket',
    viewMyTickets: 'Lihat Tiket Saya',
    transferSuccessDirect: 'Tiket ditransfer ke {{name}}',
    transferSuccessPending: 'Transfer tertunda — email klaim terkirim',
    transferFailed: 'Transfer gagal',
    cancelSuccess: 'Transfer dibatalkan',
    cancelFailed: 'Gagal membatalkan transfer',
    recipient_required: 'Masukkan email atau dompet penerima',
    invalid_recipient: 'Masukkan email atau alamat dompet Solana yang valid',
    invalid_email: 'Format email tidak valid',
    invalid_wallet: 'Alamat dompet tidak valid',
    message_too_long: 'Pesan maksimal 500 karakter',
  },

  // ─── Poin loyalitas ───────────────────────────────────────────
  loyalty: {
    balance: {
      title: 'Poin',
      titleHighlight: 'Anda',
      pointsLabel: 'poin',
      totalEarned: 'Total diperoleh',
      totalRedeemed: 'Total ditukar',
      loginStreak: 'Streak login',
      streakDays: '{{count}} hari',
    },
    points: {
      title: 'Poin',
      subtitle: 'Dapatkan poin dengan berpartisipasi di ekosistem Creatix.',
      historyTitle: 'Riwayat',
      rewardsLink: 'Hadiah',
      leaderboardLink: 'Papan peringkat',
      balanceError: 'Gagal memuat saldo. Silakan coba lagi.',
      historyError: 'Gagal memuat riwayat. Silakan coba lagi.',
      emptyHistory: 'Belum ada transaksi.',
      loadMore: 'Muat lebih banyak',
      loading: 'Memuat…',
      filterTypeAll: 'Semua jenis',
      filterTypeEarn: 'Diperoleh',
      filterTypeRedeem: 'Ditukar',
      filterSourceAll: 'Semua sumber',
      filterType: 'Jenis',
      filterSource: 'Sumber',
    },
    sources: {
      check_in: 'Check-in',
      rsvp: 'RSVP',
      review: 'Ulasan',
      event_create: 'Event dibuat',
      community_host: 'Host komunitas',
      daily_login: 'Login harian',
      redemption: 'Penukaran',
    },
    rewards: {
      title: 'Hadiah',
      subtitleLoading: 'Memuat saldo…',
      subtitleAvailable: 'Anda memiliki {{count}} poin tersedia',
      subtitleSignIn: 'Masuk untuk menukar hadiah',
      myPointsLink: 'Poin saya',
      catalogTab: 'Katalog',
      historyTab: 'Penukaran saya',
      loadError: 'Gagal memuat hadiah. Silakan coba lagi.',
      redeemSuccess: 'Hadiah berhasil ditukar!',
      redeemFailed: 'Gagal menukar hadiah',
      emptyCatalog: 'Belum ada hadiah tersedia.',
      emptyRedemptions: 'Belum ada penukaran.',
      confirmTitle: 'Konfirmasi penukaran',
      confirmDescription:
        'Tukar {{name}} dengan {{cost}} poin? Saldo Anda akan berkurang menjadi {{remaining}} poin.',
      cancel: 'Batal',
      confirm: 'Konfirmasi',
      redeeming: 'Menukar…',
      redeem: 'Tukar',
      insufficient: 'Poin tidak cukup',
      unavailable: 'Tidak tersedia',
      soldOut: 'Habis',
      remaining: '{{count}} tersisa',
      costPts: '{{cost}} poin',
      spentPts: '-{{cost}} poin',
    },
    redemptionStatus: {
      active: 'Aktif',
      used: 'Digunakan',
      expired: 'Kedaluwarsa',
      refunded: 'Dikembalikan',
    },
    leaderboard: {
      title: 'Papan peringkat',
      subtitle: 'Anggota komunitas teratas berdasarkan poin yang diperoleh.',
      myRank: 'Peringkat Anda: #{{rank}} ({{points}} poin)',
      myPointsLink: 'Poin saya',
      loadError: 'Gagal memuat papan peringkat. Silakan coba lagi.',
      empty: 'Belum ada data papan peringkat.',
      topEarners: 'Peroleh terbanyak',
      periodAll: 'Sepanjang waktu',
      periodMonthly: 'Bulanan',
      periodWeekly: 'Mingguan',
      you: 'Anda',
    },
    levels: {
      bronze: 'Perunggu',
      silver: 'Perak',
      gold: 'Emas',
      platinum: 'Platina',
    },
  },

  // ─── Bahasa ───────────────────────────────────────────────────
  language: {
    label: 'Bahasa',
    english: 'Inggris',
    indonesian: 'Indonesia',
    switchTo: 'Ganti ke {{lang}}',
    switchEn: '🇬🇧 EN',
    switchId: '🇮🇩 ID',
  },

  // ─── Social sharing ───────────────────────────────────────────
  share: {
    title: 'Bagikan',
    copyLink: 'Salin Tautan',
    linkCopied: 'Tautan disalin ke clipboard',
    embedWidget: 'Sematkan Widget',
    copyEmbedCode: 'Salin Kode Semat',
    embedCodeCopied: 'Kode semat disalin',
  },
}
